import * as Q from "react";
import se, { useState as ot, useEffect as it, forwardRef as pr, useMemo as Dn, useLayoutEffect as zn, useId as Ln } from "react";
import * as Mn from "react-dom";
function $n(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gr = {
    exports: {}
  },
  X = gr.exports = {},
  ue,
  fe;
function Et() {
  throw new Error("setTimeout has not been defined");
}
function St() {
  throw new Error("clearTimeout has not been defined");
}
(function () {
  try {
    typeof setTimeout == "function" ? ue = setTimeout : ue = Et;
  } catch {
    ue = Et;
  }
  try {
    typeof clearTimeout == "function" ? fe = clearTimeout : fe = St;
  } catch {
    fe = St;
  }
})();
function mr(e) {
  if (ue === setTimeout) return setTimeout(e, 0);
  if ((ue === Et || !ue) && setTimeout) return ue = setTimeout, setTimeout(e, 0);
  try {
    return ue(e, 0);
  } catch {
    try {
      return ue.call(null, e, 0);
    } catch {
      return ue.call(this, e, 0);
    }
  }
}
function Nn(e) {
  if (fe === clearTimeout) return clearTimeout(e);
  if ((fe === St || !fe) && clearTimeout) return fe = clearTimeout, clearTimeout(e);
  try {
    return fe(e);
  } catch {
    try {
      return fe.call(null, e);
    } catch {
      return fe.call(this, e);
    }
  }
}
var me = [],
  je = !1,
  Oe,
  et = -1;
function Wn() {
  !je || !Oe || (je = !1, Oe.length ? me = Oe.concat(me) : et = -1, me.length && hr());
}
function hr() {
  if (!je) {
    var e = mr(Wn);
    je = !0;
    for (var t = me.length; t;) {
      for (Oe = me, me = []; ++et < t;) Oe && Oe[et].run();
      et = -1, t = me.length;
    }
    Oe = null, je = !1, Nn(e);
  }
}
X.nextTick = function (e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
  me.push(new br(e, t)), me.length === 1 && !je && mr(hr);
};
function br(e, t) {
  this.fun = e, this.array = t;
}
br.prototype.run = function () {
  this.fun.apply(null, this.array);
};
X.title = "browser";
X.browser = !0;
X.env = {};
X.argv = [];
X.version = "";
X.versions = {};
function he() {}
X.on = he;
X.addListener = he;
X.once = he;
X.off = he;
X.removeListener = he;
X.removeAllListeners = he;
X.emit = he;
X.prependListener = he;
X.prependOnceListener = he;
X.listeners = function (e) {
  return [];
};
X.binding = function (e) {
  throw new Error("process.binding is not supported");
};
X.cwd = function () {
  return "/";
};
X.chdir = function (e) {
  throw new Error("process.chdir is not supported");
};
X.umask = function () {
  return 0;
};
var Bn = gr.exports;
const qe = /* @__PURE__ */$n(Bn);
function yr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ot = {
    exports: {}
  },
  Be = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tr;
function In() {
  if (tr) return Be;
  tr = 1;
  var e = se,
    t = Symbol.for("react.element"),
    r = Symbol.for("react.fragment"),
    o = Object.prototype.hasOwnProperty,
    s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    i = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function n(c, u, a) {
    var f,
      d = {},
      p = null,
      h = null;
    a !== void 0 && (p = "" + a), u.key !== void 0 && (p = "" + u.key), u.ref !== void 0 && (h = u.ref);
    for (f in u) o.call(u, f) && !i.hasOwnProperty(f) && (d[f] = u[f]);
    if (c && c.defaultProps) for (f in u = c.defaultProps, u) d[f] === void 0 && (d[f] = u[f]);
    return {
      $$typeof: t,
      type: c,
      key: p,
      ref: h,
      props: d,
      _owner: s.current
    };
  }
  return Be.Fragment = r, Be.jsx = n, Be.jsxs = n, Be;
}
var Ie = {},
  rr;
function Vn() {
  return rr || (rr = 1, qe.env.NODE_ENV !== "production" && function () {
    var e = se,
      t = Symbol.for("react.element"),
      r = Symbol.for("react.portal"),
      o = Symbol.for("react.fragment"),
      s = Symbol.for("react.strict_mode"),
      i = Symbol.for("react.profiler"),
      n = Symbol.for("react.provider"),
      c = Symbol.for("react.context"),
      u = Symbol.for("react.forward_ref"),
      a = Symbol.for("react.suspense"),
      f = Symbol.for("react.suspense_list"),
      d = Symbol.for("react.memo"),
      p = Symbol.for("react.lazy"),
      h = Symbol.for("react.offscreen"),
      m = Symbol.iterator,
      x = "@@iterator";
    function k(l) {
      if (l === null || typeof l != "object") return null;
      var b = m && l[m] || l[x];
      return typeof b == "function" ? b : null;
    }
    var P = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(l) {
      {
        for (var b = arguments.length, S = new Array(b > 1 ? b - 1 : 0), D = 1; D < b; D++) S[D - 1] = arguments[D];
        $("error", l, S);
      }
    }
    function $(l, b, S) {
      {
        var D = P.ReactDebugCurrentFrame,
          V = D.getStackAddendum();
        V !== "" && (b += "%s", S = S.concat([V]));
        var H = S.map(function (I) {
          return String(I);
        });
        H.unshift("Warning: " + b), Function.prototype.apply.call(console[l], console, H);
      }
    }
    var z = !1,
      M = !1,
      G = !1,
      Y = !1,
      J = !1,
      w;
    w = Symbol.for("react.module.reference");
    function A(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === o || l === i || J || l === s || l === a || l === f || Y || l === h || z || M || G || typeof l == "object" && l !== null && (l.$$typeof === p || l.$$typeof === d || l.$$typeof === n || l.$$typeof === c || l.$$typeof === u ||
      // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      l.$$typeof === w || l.getModuleId !== void 0));
    }
    function T(l, b, S) {
      var D = l.displayName;
      if (D) return D;
      var V = b.displayName || b.name || "";
      return V !== "" ? S + "(" + V + ")" : S;
    }
    function g(l) {
      return l.displayName || "Context";
    }
    function _(l) {
      if (l == null) return null;
      if (typeof l.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function") return l.displayName || l.name || null;
      if (typeof l == "string") return l;
      switch (l) {
        case o:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case a:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof l == "object") switch (l.$$typeof) {
        case c:
          var b = l;
          return g(b) + ".Consumer";
        case n:
          var S = l;
          return g(S._context) + ".Provider";
        case u:
          return T(l, l.render, "ForwardRef");
        case d:
          var D = l.displayName || null;
          return D !== null ? D : _(l.type) || "Memo";
        case p:
          {
            var V = l,
              H = V._payload,
              I = V._init;
            try {
              return _(I(H));
            } catch {
              return null;
            }
          }
      }
      return null;
    }
    var E = Object.assign,
      v = 0,
      O,
      y,
      C,
      F,
      j,
      U,
      Ae;
    function te() {}
    te.__reactDisabledLog = !0;
    function ke() {
      {
        if (v === 0) {
          O = console.log, y = console.info, C = console.warn, F = console.error, j = console.group, U = console.groupCollapsed, Ae = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: te,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        v++;
      }
    }
    function Me() {
      {
        if (v--, v === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: E({}, l, {
              value: O
            }),
            info: E({}, l, {
              value: y
            }),
            warn: E({}, l, {
              value: C
            }),
            error: E({}, l, {
              value: F
            }),
            group: E({}, l, {
              value: j
            }),
            groupCollapsed: E({}, l, {
              value: U
            }),
            groupEnd: E({}, l, {
              value: Ae
            })
          });
        }
        v < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ee = P.ReactCurrentDispatcher,
      re;
    function ie(l, b, S) {
      {
        if (re === void 0) try {
          throw Error();
        } catch (V) {
          var D = V.stack.trim().match(/\n( *(at )?)/);
          re = D && D[1] || "";
        }
        return `
` + re + l;
      }
    }
    var be = !1,
      Te;
    {
      var $e = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new $e();
    }
    function Bt(l, b) {
      if (!l || be) return "";
      {
        var S = Te.get(l);
        if (S !== void 0) return S;
      }
      var D;
      be = !0;
      var V = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var H;
      H = Ee.current, Ee.current = null, ke();
      try {
        if (b) {
          var I = function () {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function () {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              D = ne;
            }
            Reflect.construct(l, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              D = ne;
            }
            l.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            D = ne;
          }
          l();
        }
      } catch (ne) {
        if (ne && D && typeof ne.stack == "string") {
          for (var B = ne.stack.split(`
`), ee = D.stack.split(`
`), K = B.length - 1, Z = ee.length - 1; K >= 1 && Z >= 0 && B[K] !== ee[Z];) Z--;
          for (; K >= 1 && Z >= 0; K--, Z--) if (B[K] !== ee[Z]) {
            if (K !== 1 || Z !== 1) do if (K--, Z--, Z < 0 || B[K] !== ee[Z]) {
              var ae = `
` + B[K].replace(" at new ", " at ");
              return l.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", l.displayName)), typeof l == "function" && Te.set(l, ae), ae;
            } while (K >= 1 && Z >= 0);
            break;
          }
        }
      } finally {
        be = !1, Ee.current = H, Me(), Error.prepareStackTrace = V;
      }
      var Pe = l ? l.displayName || l.name : "",
        Se = Pe ? ie(Pe) : "";
      return typeof l == "function" && Te.set(l, Se), Se;
    }
    function un(l, b, S) {
      return Bt(l, !1);
    }
    function fn(l) {
      var b = l.prototype;
      return !!(b && b.isReactComponent);
    }
    function Xe(l, b, S) {
      if (l == null) return "";
      if (typeof l == "function") return Bt(l, fn(l));
      if (typeof l == "string") return ie(l);
      switch (l) {
        case a:
          return ie("Suspense");
        case f:
          return ie("SuspenseList");
      }
      if (typeof l == "object") switch (l.$$typeof) {
        case u:
          return un(l.render);
        case d:
          return Xe(l.type, b, S);
        case p:
          {
            var D = l,
              V = D._payload,
              H = D._init;
            try {
              return Xe(H(V), b, S);
            } catch {}
          }
      }
      return "";
    }
    var Ne = Object.prototype.hasOwnProperty,
      It = {},
      Vt = P.ReactDebugCurrentFrame;
    function Je(l) {
      if (l) {
        var b = l._owner,
          S = Xe(l.type, l._source, b ? b.type : null);
        Vt.setExtraStackFrame(S);
      } else Vt.setExtraStackFrame(null);
    }
    function dn(l, b, S, D, V) {
      {
        var H = Function.call.bind(Ne);
        for (var I in l) if (H(l, I)) {
          var B = void 0;
          try {
            if (typeof l[I] != "function") {
              var ee = Error((D || "React class") + ": " + S + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw ee.name = "Invariant Violation", ee;
            }
            B = l[I](b, I, D, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (K) {
            B = K;
          }
          B && !(B instanceof Error) && (Je(V), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", D || "React class", S, I, typeof B), Je(null)), B instanceof Error && !(B.message in It) && (It[B.message] = !0, Je(V), R("Failed %s type: %s", S, B.message), Je(null));
        }
      }
    }
    var pn = Array.isArray;
    function dt(l) {
      return pn(l);
    }
    function gn(l) {
      {
        var b = typeof Symbol == "function" && Symbol.toStringTag,
          S = b && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return S;
      }
    }
    function mn(l) {
      try {
        return Ut(l), !1;
      } catch {
        return !0;
      }
    }
    function Ut(l) {
      return "" + l;
    }
    function Ht(l) {
      if (mn(l)) return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", gn(l)), Ut(l);
    }
    var We = P.ReactCurrentOwner,
      hn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      },
      Gt,
      qt,
      pt;
    pt = {};
    function bn(l) {
      if (Ne.call(l, "ref")) {
        var b = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (b && b.isReactWarning) return !1;
      }
      return l.ref !== void 0;
    }
    function yn(l) {
      if (Ne.call(l, "key")) {
        var b = Object.getOwnPropertyDescriptor(l, "key").get;
        if (b && b.isReactWarning) return !1;
      }
      return l.key !== void 0;
    }
    function xn(l, b) {
      if (typeof l.ref == "string" && We.current && b && We.current.stateNode !== b) {
        var S = _(We.current.type);
        pt[S] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', _(We.current.type), l.ref), pt[S] = !0);
      }
    }
    function vn(l, b) {
      {
        var S = function () {
          Gt || (Gt = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
        };
        S.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: S,
          configurable: !0
        });
      }
    }
    function wn(l, b) {
      {
        var S = function () {
          qt || (qt = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
        };
        S.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: S,
          configurable: !0
        });
      }
    }
    var _n = function (l, b, S, D, V, H, I) {
      var B = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: l,
        key: b,
        ref: S,
        props: I,
        // Record the component responsible for creating this element.
        _owner: H
      };
      return B._store = {}, Object.defineProperty(B._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(B, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: D
      }), Object.defineProperty(B, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: V
      }), Object.freeze && (Object.freeze(B.props), Object.freeze(B)), B;
    };
    function Cn(l, b, S, D, V) {
      {
        var H,
          I = {},
          B = null,
          ee = null;
        S !== void 0 && (Ht(S), B = "" + S), yn(b) && (Ht(b.key), B = "" + b.key), bn(b) && (ee = b.ref, xn(b, V));
        for (H in b) Ne.call(b, H) && !hn.hasOwnProperty(H) && (I[H] = b[H]);
        if (l && l.defaultProps) {
          var K = l.defaultProps;
          for (H in K) I[H] === void 0 && (I[H] = K[H]);
        }
        if (B || ee) {
          var Z = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          B && vn(I, Z), ee && wn(I, Z);
        }
        return _n(l, B, ee, V, D, We.current, I);
      }
    }
    var gt = P.ReactCurrentOwner,
      Yt = P.ReactDebugCurrentFrame;
    function Re(l) {
      if (l) {
        var b = l._owner,
          S = Xe(l.type, l._source, b ? b.type : null);
        Yt.setExtraStackFrame(S);
      } else Yt.setExtraStackFrame(null);
    }
    var mt;
    mt = !1;
    function ht(l) {
      return typeof l == "object" && l !== null && l.$$typeof === t;
    }
    function Kt() {
      {
        if (gt.current) {
          var l = _(gt.current.type);
          if (l) return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function kn(l) {
      return "";
    }
    var Xt = {};
    function En(l) {
      {
        var b = Kt();
        if (!b) {
          var S = typeof l == "string" ? l : l.displayName || l.name;
          S && (b = `

Check the top-level render call using <` + S + ">.");
        }
        return b;
      }
    }
    function Jt(l, b) {
      {
        if (!l._store || l._store.validated || l.key != null) return;
        l._store.validated = !0;
        var S = En(b);
        if (Xt[S]) return;
        Xt[S] = !0;
        var D = "";
        l && l._owner && l._owner !== gt.current && (D = " It was passed a child from " + _(l._owner.type) + "."), Re(l), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, D), Re(null);
      }
    }
    function Zt(l, b) {
      {
        if (typeof l != "object") return;
        if (dt(l)) for (var S = 0; S < l.length; S++) {
          var D = l[S];
          ht(D) && Jt(D, b);
        } else if (ht(l)) l._store && (l._store.validated = !0);else if (l) {
          var V = k(l);
          if (typeof V == "function" && V !== l.entries) for (var H = V.call(l), I; !(I = H.next()).done;) ht(I.value) && Jt(I.value, b);
        }
      }
    }
    function Sn(l) {
      {
        var b = l.type;
        if (b == null || typeof b == "string") return;
        var S;
        if (typeof b == "function") S = b.propTypes;else if (typeof b == "object" && (b.$$typeof === u ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        b.$$typeof === d)) S = b.propTypes;else return;
        if (S) {
          var D = _(b);
          dn(S, l.props, "prop", D, l);
        } else if (b.PropTypes !== void 0 && !mt) {
          mt = !0;
          var V = _(b);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", V || "Unknown");
        }
        typeof b.getDefaultProps == "function" && !b.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function On(l) {
      {
        for (var b = Object.keys(l.props), S = 0; S < b.length; S++) {
          var D = b[S];
          if (D !== "children" && D !== "key") {
            Re(l), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", D), Re(null);
            break;
          }
        }
        l.ref !== null && (Re(l), R("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
      }
    }
    var Qt = {};
    function er(l, b, S, D, V, H) {
      {
        var I = A(l);
        if (!I) {
          var B = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (B += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ee = kn();
          ee ? B += ee : B += Kt();
          var K;
          l === null ? K = "null" : dt(l) ? K = "array" : l !== void 0 && l.$$typeof === t ? (K = "<" + (_(l.type) || "Unknown") + " />", B = " Did you accidentally export a JSX literal instead of a component?") : K = typeof l, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, B);
        }
        var Z = Cn(l, b, S, V, H);
        if (Z == null) return Z;
        if (I) {
          var ae = b.children;
          if (ae !== void 0) if (D) {
            if (dt(ae)) {
              for (var Pe = 0; Pe < ae.length; Pe++) Zt(ae[Pe], l);
              Object.freeze && Object.freeze(ae);
            } else R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          } else Zt(ae, l);
        }
        if (Ne.call(b, "key")) {
          var Se = _(l),
            ne = Object.keys(b).filter(function (Fn) {
              return Fn !== "key";
            }),
            bt = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Qt[Se + bt]) {
            var jn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            R(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, bt, Se, jn, Se), Qt[Se + bt] = !0;
          }
        }
        return l === o ? On(Z) : Sn(Z), Z;
      }
    }
    function An(l, b, S) {
      return er(l, b, S, !0);
    }
    function Tn(l, b, S) {
      return er(l, b, S, !1);
    }
    var Rn = Tn,
      Pn = An;
    Ie.Fragment = o, Ie.jsx = Rn, Ie.jsxs = Pn;
  }()), Ie;
}
qe.env.NODE_ENV === "production" ? Ot.exports = In() : Ot.exports = Vn();
var L = Ot.exports;
function Un(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  const [r, o] = ot(e);
  return it(() => {
    const s = setTimeout(() => {
      o(e);
    }, t);
    return () => {
      clearTimeout(s);
    };
  }, [e, t]), r;
}
var xr = {},
  vr = {},
  Rt = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  function t(r) {
    if (r = `${r}`, r === "0") return "0";
    if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(r)) return r.replace(/^[+-]?/, s => s === "-" ? "" : "-");
    let o = ["var", "calc", "min", "max", "clamp"];
    for (const s of o) if (r.includes(`${s}(`)) return `calc(${r} * -1)`;
  }
})(Rt);
var wr = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  const t = ["preflight", "container", "accessibility", "pointerEvents", "visibility", "position", "inset", "isolation", "zIndex", "order", "gridColumn", "gridColumnStart", "gridColumnEnd", "gridRow", "gridRowStart", "gridRowEnd", "float", "clear", "margin", "boxSizing", "lineClamp", "display", "aspectRatio", "size", "height", "maxHeight", "minHeight", "width", "minWidth", "maxWidth", "flex", "flexShrink", "flexGrow", "flexBasis", "tableLayout", "captionSide", "borderCollapse", "borderSpacing", "transformOrigin", "translate", "rotate", "skew", "scale", "transform", "animation", "cursor", "touchAction", "userSelect", "resize", "scrollSnapType", "scrollSnapAlign", "scrollSnapStop", "scrollMargin", "scrollPadding", "listStylePosition", "listStyleType", "listStyleImage", "appearance", "columns", "breakBefore", "breakInside", "breakAfter", "gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateColumns", "gridTemplateRows", "flexDirection", "flexWrap", "placeContent", "placeItems", "alignContent", "alignItems", "justifyContent", "justifyItems", "gap", "space", "divideWidth", "divideStyle", "divideColor", "divideOpacity", "placeSelf", "alignSelf", "justifySelf", "overflow", "overscrollBehavior", "scrollBehavior", "textOverflow", "hyphens", "whitespace", "textWrap", "wordBreak", "borderRadius", "borderWidth", "borderStyle", "borderColor", "borderOpacity", "backgroundColor", "backgroundOpacity", "backgroundImage", "gradientColorStops", "boxDecorationBreak", "backgroundSize", "backgroundAttachment", "backgroundClip", "backgroundPosition", "backgroundRepeat", "backgroundOrigin", "fill", "stroke", "strokeWidth", "objectFit", "objectPosition", "padding", "textAlign", "textIndent", "verticalAlign", "fontFamily", "fontSize", "fontWeight", "textTransform", "fontStyle", "fontVariantNumeric", "lineHeight", "letterSpacing", "textColor", "textOpacity", "textDecoration", "textDecorationColor", "textDecorationStyle", "textDecorationThickness", "textUnderlineOffset", "fontSmoothing", "placeholderColor", "placeholderOpacity", "caretColor", "accentColor", "opacity", "backgroundBlendMode", "mixBlendMode", "boxShadow", "boxShadowColor", "outlineStyle", "outlineWidth", "outlineOffset", "outlineColor", "ringWidth", "ringColor", "ringOpacity", "ringOffsetWidth", "ringOffsetColor", "blur", "brightness", "contrast", "dropShadow", "grayscale", "hueRotate", "invert", "saturate", "sepia", "filter", "backdropBlur", "backdropBrightness", "backdropContrast", "backdropGrayscale", "backdropHueRotate", "backdropInvert", "backdropOpacity", "backdropSaturate", "backdropSepia", "backdropFilter", "transitionProperty", "transitionDelay", "transitionDuration", "transitionTimingFunction", "willChange", "contain", "content", "forcedColorAdjust"];
})(wr);
var _r = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  function t(r, o) {
    return r === void 0 ? o : Array.isArray(r) ? r : [...new Set(o.filter(i => r !== !1 && r[i] !== !1).concat(Object.keys(r).filter(i => r[i] !== !1)))];
  }
})(_r);
var Cr = {},
  at = {},
  Pt = {
    exports: {}
  },
  N = String,
  kr = function () {
    return {
      isColorSupported: !1,
      reset: N,
      bold: N,
      dim: N,
      italic: N,
      underline: N,
      inverse: N,
      hidden: N,
      strikethrough: N,
      black: N,
      red: N,
      green: N,
      yellow: N,
      blue: N,
      magenta: N,
      cyan: N,
      white: N,
      gray: N,
      bgBlack: N,
      bgRed: N,
      bgGreen: N,
      bgYellow: N,
      bgBlue: N,
      bgMagenta: N,
      bgCyan: N,
      bgWhite: N,
      blackBright: N,
      redBright: N,
      greenBright: N,
      yellowBright: N,
      blueBright: N,
      magentaBright: N,
      cyanBright: N,
      whiteBright: N,
      bgBlackBright: N,
      bgRedBright: N,
      bgGreenBright: N,
      bgYellowBright: N,
      bgBlueBright: N,
      bgMagentaBright: N,
      bgCyanBright: N,
      bgWhiteBright: N
    };
  };
Pt.exports = kr();
Pt.exports.createColors = kr;
var Er = Pt.exports;
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(u, a) {
    for (var f in a) Object.defineProperty(u, f, {
      enumerable: !0,
      get: a[f]
    });
  }
  t(e, {
    dim: function () {
      return n;
    },
    default: function () {
      return c;
    }
  });
  const r = /* @__PURE__ */o(Er);
  function o(u) {
    return u && u.__esModule ? u : {
      default: u
    };
  }
  let s = /* @__PURE__ */new Set();
  function i(u, a, f) {
    typeof qe < "u" && qe.env.JEST_WORKER_ID || f && s.has(f) || (f && s.add(f), console.warn(""), a.forEach(d => console.warn(u, "-", d)));
  }
  function n(u) {
    return r.default.dim(u);
  }
  const c = {
    info(u, a) {
      i(r.default.bold(r.default.cyan("info")), ...(Array.isArray(u) ? [u] : [a, u]));
    },
    warn(u, a) {
      i(r.default.bold(r.default.yellow("warn")), ...(Array.isArray(u) ? [u] : [a, u]));
    },
    risk(u, a) {
      i(r.default.bold(r.default.magenta("risk")), ...(Array.isArray(u) ? [u] : [a, u]));
    }
  };
})(at);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return s;
    }
  });
  const t = /* @__PURE__ */r(at);
  function r(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  function o(_ref) {
    let {
      version: i,
      from: n,
      to: c
    } = _ref;
    t.default.warn(`${n}-color-renamed`, [`As of Tailwind CSS ${i}, \`${n}\` has been renamed to \`${c}\`.`, "Update your configuration file to silence this warning."]);
  }
  const s = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      return o({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      }), this.sky;
    },
    get warmGray() {
      return o({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      }), this.stone;
    },
    get trueGray() {
      return o({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      }), this.neutral;
    },
    get coolGray() {
      return o({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      }), this.gray;
    },
    get blueGray() {
      return o({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      }), this.slate;
    }
  };
})(Cr);
var Sr = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "defaults", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  function t(r) {
    for (var _len = arguments.length, o = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      o[_key - 1] = arguments[_key];
    }
    for (let n of o) {
      for (let c in n) {
        var s;
        !(r == null || (s = r.hasOwnProperty) === null || s === void 0) && s.call(r, c) || (r[c] = n[c]);
      }
      for (let c of Object.getOwnPropertySymbols(n)) {
        var i;
        !(r == null || (i = r.hasOwnProperty) === null || i === void 0) && i.call(r, c) || (r[c] = n[c]);
      }
    }
    return r;
  }
})(Sr);
var Or = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "toPath", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  function t(r) {
    if (Array.isArray(r)) return r;
    let o = r.split("[").length - 1,
      s = r.split("]").length - 1;
    if (o !== s) throw new Error(`Path is invalid. Has unbalanced brackets: ${r}`);
    return r.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
  }
})(Or);
var Ar = {},
  st = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(d, p) {
    for (var h in p) Object.defineProperty(d, h, {
      enumerable: !0,
      get: p[h]
    });
  }
  t(e, {
    flagEnabled: function () {
      return c;
    },
    issueFlagNotices: function () {
      return a;
    },
    default: function () {
      return f;
    }
  });
  const r = /* @__PURE__ */s(Er),
    o = /* @__PURE__ */s(at);
  function s(d) {
    return d && d.__esModule ? d : {
      default: d
    };
  }
  let i = {
      optimizeUniversalDefaults: !1,
      generalizedModifiers: !0,
      disableColorOpacityUtilitiesByDefault: !1,
      relativeContentPathsByDefault: !1
    },
    n = {
      future: ["hoverOnlyWhenSupported", "respectDefaultRingColorOpacity", "disableColorOpacityUtilitiesByDefault", "relativeContentPathsByDefault"],
      experimental: ["optimizeUniversalDefaults", "generalizedModifiers"]
    };
  function c(d, p) {
    if (n.future.includes(p)) {
      var h, m, x;
      return d.future === "all" || ((x = (m = d == null || (h = d.future) === null || h === void 0 ? void 0 : h[p]) !== null && m !== void 0 ? m : i[p]) !== null && x !== void 0 ? x : !1);
    }
    if (n.experimental.includes(p)) {
      var k, P, R;
      return d.experimental === "all" || ((R = (P = d == null || (k = d.experimental) === null || k === void 0 ? void 0 : k[p]) !== null && P !== void 0 ? P : i[p]) !== null && R !== void 0 ? R : !1);
    }
    return !1;
  }
  function u(d) {
    if (d.experimental === "all") return n.experimental;
    var p;
    return Object.keys((p = d == null ? void 0 : d.experimental) !== null && p !== void 0 ? p : {}).filter(h => n.experimental.includes(h) && d.experimental[h]);
  }
  function a(d) {
    if (qe.env.JEST_WORKER_ID === void 0 && u(d).length > 0) {
      let p = u(d).map(h => r.default.yellow(h)).join(", ");
      o.default.warn("experimental-flags-enabled", [`You have enabled experimental features: ${p}`, "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."]);
    }
  }
  const f = n;
})(st);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "normalizeConfig", {
    enumerable: !0,
    get: function () {
      return i;
    }
  });
  const t = st,
    r = /* @__PURE__ */s(at);
  function o(n) {
    if (typeof WeakMap != "function") return null;
    var c = /* @__PURE__ */new WeakMap(),
      u = /* @__PURE__ */new WeakMap();
    return (o = function (a) {
      return a ? u : c;
    })(n);
  }
  function s(n, c) {
    if (n && n.__esModule) return n;
    if (n === null || typeof n != "object" && typeof n != "function") return {
      default: n
    };
    var u = o(c);
    if (u && u.has(n)) return u.get(n);
    var a = {},
      f = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var d in n) if (d !== "default" && Object.prototype.hasOwnProperty.call(n, d)) {
      var p = f ? Object.getOwnPropertyDescriptor(n, d) : null;
      p && (p.get || p.set) ? Object.defineProperty(a, d, p) : a[d] = n[d];
    }
    return a.default = n, u && u.set(n, a), a;
  }
  function i(n) {
    if ((() => {
      if (n.purge || !n.content || !Array.isArray(n.content) && !(typeof n.content == "object" && n.content !== null)) return !1;
      if (Array.isArray(n.content)) return n.content.every(a => typeof a == "string" ? !0 : !(typeof (a == null ? void 0 : a.raw) != "string" || a != null && a.extension && typeof (a == null ? void 0 : a.extension) != "string"));
      if (typeof n.content == "object" && n.content !== null) {
        if (Object.keys(n.content).some(a => !["files", "relative", "extract", "transform"].includes(a))) return !1;
        if (Array.isArray(n.content.files)) {
          if (!n.content.files.every(a => typeof a == "string" ? !0 : !(typeof (a == null ? void 0 : a.raw) != "string" || a != null && a.extension && typeof (a == null ? void 0 : a.extension) != "string"))) return !1;
          if (typeof n.content.extract == "object") {
            for (let a of Object.values(n.content.extract)) if (typeof a != "function") return !1;
          } else if (!(n.content.extract === void 0 || typeof n.content.extract == "function")) return !1;
          if (typeof n.content.transform == "object") {
            for (let a of Object.values(n.content.transform)) if (typeof a != "function") return !1;
          } else if (!(n.content.transform === void 0 || typeof n.content.transform == "function")) return !1;
          if (typeof n.content.relative != "boolean" && typeof n.content.relative < "u") return !1;
        }
        return !0;
      }
      return !1;
    })() || r.default.warn("purge-deprecation", ["The `purge`/`content` options have changed in Tailwind CSS v3.0.", "Update your configuration file to eliminate this warning.", "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"]), n.safelist = (() => {
      var a;
      let {
        content: f,
        purge: d,
        safelist: p
      } = n;
      return Array.isArray(p) ? p : Array.isArray(f == null ? void 0 : f.safelist) ? f.safelist : Array.isArray(d == null ? void 0 : d.safelist) ? d.safelist : Array.isArray(d == null || (a = d.options) === null || a === void 0 ? void 0 : a.safelist) ? d.options.safelist : [];
    })(), n.blocklist = (() => {
      let {
        blocklist: a
      } = n;
      if (Array.isArray(a)) {
        if (a.every(f => typeof f == "string")) return a;
        r.default.warn("blocklist-invalid", ["The `blocklist` option must be an array of strings.", "https://tailwindcss.com/docs/content-configuration#discarding-classes"]);
      }
      return [];
    })(), typeof n.prefix == "function") r.default.warn("prefix-function", ["As of Tailwind CSS v3.0, `prefix` cannot be a function.", "Update `prefix` in your configuration to be a string to eliminate this warning.", "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"]), n.prefix = "";else {
      var u;
      n.prefix = (u = n.prefix) !== null && u !== void 0 ? u : "";
    }
    n.content = {
      relative: (() => {
        let {
          content: a
        } = n;
        return a != null && a.relative ? a.relative : (0, t.flagEnabled)(n, "relativeContentPathsByDefault");
      })(),
      files: (() => {
        let {
          content: a,
          purge: f
        } = n;
        return Array.isArray(f) ? f : Array.isArray(f == null ? void 0 : f.content) ? f.content : Array.isArray(a) ? a : Array.isArray(a == null ? void 0 : a.content) ? a.content : Array.isArray(a == null ? void 0 : a.files) ? a.files : [];
      })(),
      extract: (() => {
        let a = (() => {
            var p, h, m, x, k, P, R, $, z, M;
            return !((p = n.purge) === null || p === void 0) && p.extract ? n.purge.extract : !((h = n.content) === null || h === void 0) && h.extract ? n.content.extract : !((m = n.purge) === null || m === void 0 || (x = m.extract) === null || x === void 0) && x.DEFAULT ? n.purge.extract.DEFAULT : !((k = n.content) === null || k === void 0 || (P = k.extract) === null || P === void 0) && P.DEFAULT ? n.content.extract.DEFAULT : !((R = n.purge) === null || R === void 0 || ($ = R.options) === null || $ === void 0) && $.extractors ? n.purge.options.extractors : !((z = n.content) === null || z === void 0 || (M = z.options) === null || M === void 0) && M.extractors ? n.content.options.extractors : {};
          })(),
          f = {},
          d = (() => {
            var p, h, m, x;
            if (!((p = n.purge) === null || p === void 0 || (h = p.options) === null || h === void 0) && h.defaultExtractor) return n.purge.options.defaultExtractor;
            if (!((m = n.content) === null || m === void 0 || (x = m.options) === null || x === void 0) && x.defaultExtractor) return n.content.options.defaultExtractor;
          })();
        if (d !== void 0 && (f.DEFAULT = d), typeof a == "function") f.DEFAULT = a;else if (Array.isArray(a)) for (let {
          extensions: p,
          extractor: h
        } of a !== null && a !== void 0 ? a : []) for (let m of p) f[m] = h;else typeof a == "object" && a !== null && Object.assign(f, a);
        return f;
      })(),
      transform: (() => {
        let a = (() => {
            var d, p, h, m, x, k;
            return !((d = n.purge) === null || d === void 0) && d.transform ? n.purge.transform : !((p = n.content) === null || p === void 0) && p.transform ? n.content.transform : !((h = n.purge) === null || h === void 0 || (m = h.transform) === null || m === void 0) && m.DEFAULT ? n.purge.transform.DEFAULT : !((x = n.content) === null || x === void 0 || (k = x.transform) === null || k === void 0) && k.DEFAULT ? n.content.transform.DEFAULT : {};
          })(),
          f = {};
        return typeof a == "function" ? f.DEFAULT = a : typeof a == "object" && a !== null && Object.assign(f, a), f;
      })()
    };
    for (let a of n.content.files) if (typeof a == "string" && /{([^,]*?)}/g.test(a)) {
      r.default.warn("invalid-glob-braces", [`The glob pattern ${(0, r.dim)(a)} in your Tailwind CSS configuration is invalid.`, `Update it to ${(0, r.dim)(a.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`]);
      break;
    }
    return n;
  }
})(Ar);
var Tr = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  function t(r) {
    if (Object.prototype.toString.call(r) !== "[object Object]") return !1;
    const o = Object.getPrototypeOf(r);
    return o === null || Object.getPrototypeOf(o) === null;
  }
})(Tr);
var jt = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "cloneDeep", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  function t(r) {
    return Array.isArray(r) ? r.map(o => t(o)) : typeof r == "object" && r !== null ? Object.fromEntries(Object.entries(r).map(_ref2 => {
      let [o, s] = _ref2;
      return [o, t(s)];
    })) : r;
  }
})(jt);
var Rr = {},
  Pr = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  function t(r) {
    return r.replace(/\\,/g, "\\2c ");
  }
})(Pr);
var Ft = {},
  Dt = {},
  jr = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  const t = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  };
})(jr);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(m, x) {
    for (var k in x) Object.defineProperty(m, k, {
      enumerable: !0,
      get: x[k]
    });
  }
  t(e, {
    parseColor: function () {
      return p;
    },
    formatColor: function () {
      return h;
    }
  });
  const r = /* @__PURE__ */o(jr);
  function o(m) {
    return m && m.__esModule ? m : {
      default: m
    };
  }
  let s = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i,
    i = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i,
    n = /(?:\d+|\d*\.\d+)%?/,
    c = /(?:\s*,\s*|\s+)/,
    u = /\s*[,/]\s*/,
    a = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/,
    f = new RegExp(`^(rgba?)\\(\\s*(${n.source}|${a.source})(?:${c.source}(${n.source}|${a.source}))?(?:${c.source}(${n.source}|${a.source}))?(?:${u.source}(${n.source}|${a.source}))?\\s*\\)$`),
    d = new RegExp(`^(hsla?)\\(\\s*((?:${n.source})(?:deg|rad|grad|turn)?|${a.source})(?:${c.source}(${n.source}|${a.source}))?(?:${c.source}(${n.source}|${a.source}))?(?:${u.source}(${n.source}|${a.source}))?\\s*\\)$`);
  function p(m) {
    let {
      loose: x = !1
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var k, P;
    if (typeof m != "string") return null;
    if (m = m.trim(), m === "transparent") return {
      mode: "rgb",
      color: ["0", "0", "0"],
      alpha: "0"
    };
    if (m in r.default) return {
      mode: "rgb",
      color: r.default[m].map(G => G.toString())
    };
    let R = m.replace(i, (G, Y, J, w, A) => ["#", Y, Y, J, J, w, w, A ? A + A : ""].join("")).match(s);
    if (R !== null) return {
      mode: "rgb",
      color: [parseInt(R[1], 16), parseInt(R[2], 16), parseInt(R[3], 16)].map(G => G.toString()),
      alpha: R[4] ? (parseInt(R[4], 16) / 255).toString() : void 0
    };
    var $;
    let z = ($ = m.match(f)) !== null && $ !== void 0 ? $ : m.match(d);
    if (z === null) return null;
    let M = [z[2], z[3], z[4]].filter(Boolean).map(G => G.toString());
    return M.length === 2 && M[0].startsWith("var(") ? {
      mode: z[1],
      color: [M[0]],
      alpha: M[1]
    } : !x && M.length !== 3 || M.length < 3 && !M.some(G => /^var\(.*?\)$/.test(G)) ? null : {
      mode: z[1],
      color: M,
      alpha: (k = z[5]) === null || k === void 0 || (P = k.toString) === null || P === void 0 ? void 0 : P.call(k)
    };
  }
  function h(_ref3) {
    let {
      mode: m,
      color: x,
      alpha: k
    } = _ref3;
    let P = k !== void 0;
    return m === "rgba" || m === "hsla" ? `${m}(${x.join(", ")}${P ? `, ${k}` : ""})` : `${m}(${x.join(" ")}${P ? ` / ${k}` : ""})`;
  }
})(Dt);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(i, n) {
    for (var c in n) Object.defineProperty(i, c, {
      enumerable: !0,
      get: n[c]
    });
  }
  t(e, {
    withAlphaValue: function () {
      return o;
    },
    default: function () {
      return s;
    }
  });
  const r = Dt;
  function o(i, n, c) {
    if (typeof i == "function") return i({
      opacityValue: n
    });
    let u = (0, r.parseColor)(i, {
      loose: !0
    });
    return u === null ? c : (0, r.formatColor)({
      ...u,
      alpha: n
    });
  }
  function s(_ref4) {
    let {
      color: i,
      property: n,
      variable: c
    } = _ref4;
    let u = [].concat(n);
    if (typeof i == "function") return {
      [c]: "1",
      ...Object.fromEntries(u.map(f => [f, i({
        opacityVariable: c,
        opacityValue: `var(${c})`
      })]))
    };
    const a = (0, r.parseColor)(i);
    return a === null ? Object.fromEntries(u.map(f => [f, i])) : a.alpha !== void 0 ? Object.fromEntries(u.map(f => [f, i])) : {
      [c]: "1",
      ...Object.fromEntries(u.map(f => [f, (0, r.formatColor)({
        ...a,
        alpha: `var(${c})`
      })]))
    };
  }
})(Ft);
var zt = {},
  Fr = {},
  lt = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "splitAtTopLevelOnly", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  function t(r, o) {
    let s = [],
      i = [],
      n = 0,
      c = !1;
    for (let u = 0; u < r.length; u++) {
      let a = r[u];
      s.length === 0 && a === o[0] && !c && (o.length === 1 || r.slice(u, u + o.length) === o) && (i.push(r.slice(n, u)), n = u + o.length), c = c ? !1 : a === "\\", a === "(" || a === "[" || a === "{" ? s.push(a) : (a === ")" && s[s.length - 1] === "(" || a === "]" && s[s.length - 1] === "[" || a === "}" && s[s.length - 1] === "{") && s.pop();
    }
    return i.push(r.slice(n)), i;
  }
})(lt);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(u, a) {
    for (var f in a) Object.defineProperty(u, f, {
      enumerable: !0,
      get: a[f]
    });
  }
  t(e, {
    parseBoxShadowValue: function () {
      return n;
    },
    formatBoxShadowValue: function () {
      return c;
    }
  });
  const r = lt;
  let o = /* @__PURE__ */new Set(["inset", "inherit", "initial", "revert", "unset"]),
    s = /\ +(?![^(]*\))/g,
    i = /^-?(\d+|\.\d+)(.*?)$/g;
  function n(u) {
    return (0, r.splitAtTopLevelOnly)(u, ",").map(f => {
      let d = f.trim(),
        p = {
          raw: d
        },
        h = d.split(s),
        m = /* @__PURE__ */new Set();
      for (let x of h) i.lastIndex = 0, !m.has("KEYWORD") && o.has(x) ? (p.keyword = x, m.add("KEYWORD")) : i.test(x) ? m.has("X") ? m.has("Y") ? m.has("BLUR") ? m.has("SPREAD") || (p.spread = x, m.add("SPREAD")) : (p.blur = x, m.add("BLUR")) : (p.y = x, m.add("Y")) : (p.x = x, m.add("X")) : p.color ? (p.unknown || (p.unknown = []), p.unknown.push(x)) : p.color = x;
      return p.valid = p.x !== void 0 && p.y !== void 0, p;
    });
  }
  function c(u) {
    return u.map(a => a.valid ? [a.keyword, a.x, a.y, a.blur, a.spread, a.color].filter(Boolean).join(" ") : a.raw).join(", ");
  }
})(Fr);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(y, C) {
    for (var F in C) Object.defineProperty(y, F, {
      enumerable: !0,
      get: C[F]
    });
  }
  t(e, {
    normalize: function () {
      return u;
    },
    normalizeAttributeSelectors: function () {
      return a;
    },
    url: function () {
      return d;
    },
    number: function () {
      return p;
    },
    percentage: function () {
      return h;
    },
    length: function () {
      return k;
    },
    lineWidth: function () {
      return R;
    },
    shadow: function () {
      return $;
    },
    color: function () {
      return z;
    },
    image: function () {
      return M;
    },
    gradient: function () {
      return Y;
    },
    position: function () {
      return w;
    },
    familyName: function () {
      return A;
    },
    genericName: function () {
      return g;
    },
    absoluteSize: function () {
      return E;
    },
    relativeSize: function () {
      return O;
    }
  });
  const r = Dt,
    o = Fr,
    s = lt;
  let i = ["min", "max", "clamp", "calc"];
  function n(y) {
    return i.some(C => new RegExp(`^${C}\\(.*\\)`).test(y));
  }
  const c = /* @__PURE__ */new Set([
  // Concrete properties
  "scroll-timeline-name", "timeline-scope", "view-timeline-name", "font-palette", "anchor-name", "anchor-scope", "position-anchor", "position-try-options",
  // Shorthand properties
  "scroll-timeline", "animation-timeline", "view-timeline", "position-try"]);
  function u(y) {
    let C = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let F = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
    let j = C && c.has(C.property);
    return y.startsWith("--") && !j ? `var(${y})` : y.includes("url(") ? y.split(/(url\(.*?\))/g).filter(Boolean).map(U => /^url\(.*?\)$/.test(U) ? U : u(U, C, !1)).join("") : (y = y.replace(/([^\\])_+/g, (U, Ae) => Ae + " ".repeat(U.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), F && (y = y.trim()), y = f(y), y);
  }
  function a(y) {
    return y.includes("=") && (y = y.replace(/(=.*)/g, (C, F) => {
      if (F[1] === "'" || F[1] === '"') return F;
      if (F.length > 2) {
        let j = F[F.length - 1];
        if (F[F.length - 2] === " " && (j === "i" || j === "I" || j === "s" || j === "S")) return `="${F.slice(1, -2)}" ${F[F.length - 1]}`;
      }
      return `="${F.slice(1)}"`;
    })), y;
  }
  function f(y) {
    let C = ["theme"],
      F = ["min-content", "max-content", "fit-content",
      // Env
      "safe-area-inset-top", "safe-area-inset-right", "safe-area-inset-bottom", "safe-area-inset-left", "titlebar-area-x", "titlebar-area-y", "titlebar-area-width", "titlebar-area-height", "keyboard-inset-top", "keyboard-inset-right", "keyboard-inset-bottom", "keyboard-inset-left", "keyboard-inset-width", "keyboard-inset-height", "radial-gradient", "linear-gradient", "conic-gradient", "repeating-radial-gradient", "repeating-linear-gradient", "repeating-conic-gradient", "anchor-size"];
    return y.replace(/(calc|min|max|clamp)\(.+\)/g, j => {
      let U = "";
      function Ae() {
        let te = U.trimEnd();
        return te[te.length - 1];
      }
      for (let te = 0; te < j.length; te++) {
        let ke = function (re) {
            return re.split("").every((ie, be) => j[te + be] === ie);
          },
          Me = function (re) {
            let ie = 1 / 0;
            for (let Te of re) {
              let $e = j.indexOf(Te, te);
              $e !== -1 && $e < ie && (ie = $e);
            }
            let be = j.slice(te, ie);
            return te += be.length - 1, be;
          },
          Ee = j[te];
        if (ke("var")) U += Me([")", ","]);else if (F.some(re => ke(re))) {
          let re = F.find(ie => ke(ie));
          U += re, te += re.length - 1;
        } else C.some(re => ke(re)) ? U += Me([")"]) : ke("[") ? U += Me(["]"]) : ["+", "-", "*", "/"].includes(Ee) && !["(", "+", "-", "*", "/", ","].includes(Ae()) ? U += ` ${Ee} ` : U += Ee;
      }
      return U.replace(/\s+/g, " ");
    });
  }
  function d(y) {
    return y.startsWith("url(");
  }
  function p(y) {
    return !isNaN(Number(y)) || n(y);
  }
  function h(y) {
    return y.endsWith("%") && p(y.slice(0, -1)) || n(y);
  }
  let x = `(?:${["cm", "mm", "Q", "in", "pc", "pt", "px", "em", "ex", "ch", "rem", "lh", "rlh", "vw", "vh", "vmin", "vmax", "vb", "vi", "svw", "svh", "lvw", "lvh", "dvw", "dvh", "cqw", "cqh", "cqi", "cqb", "cqmin", "cqmax"].join("|")})`;
  function k(y) {
    return y === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${x}$`).test(y) || n(y);
  }
  let P = /* @__PURE__ */new Set(["thin", "medium", "thick"]);
  function R(y) {
    return P.has(y);
  }
  function $(y) {
    let C = (0, o.parseBoxShadowValue)(u(y));
    for (let F of C) if (!F.valid) return !1;
    return !0;
  }
  function z(y) {
    let C = 0;
    return (0, s.splitAtTopLevelOnly)(y, "_").every(j => (j = u(j), j.startsWith("var(") ? !0 : (0, r.parseColor)(j, {
      loose: !0
    }) !== null ? (C++, !0) : !1)) ? C > 0 : !1;
  }
  function M(y) {
    let C = 0;
    return (0, s.splitAtTopLevelOnly)(y, ",").every(j => (j = u(j), j.startsWith("var(") ? !0 : d(j) || Y(j) || ["element(", "image(", "cross-fade(", "image-set("].some(U => j.startsWith(U)) ? (C++, !0) : !1)) ? C > 0 : !1;
  }
  let G = /* @__PURE__ */new Set(["conic-gradient", "linear-gradient", "radial-gradient", "repeating-conic-gradient", "repeating-linear-gradient", "repeating-radial-gradient"]);
  function Y(y) {
    y = u(y);
    for (let C of G) if (y.startsWith(`${C}(`)) return !0;
    return !1;
  }
  let J = /* @__PURE__ */new Set(["center", "top", "right", "bottom", "left"]);
  function w(y) {
    let C = 0;
    return (0, s.splitAtTopLevelOnly)(y, "_").every(j => (j = u(j), j.startsWith("var(") ? !0 : J.has(j) || k(j) || h(j) ? (C++, !0) : !1)) ? C > 0 : !1;
  }
  function A(y) {
    let C = 0;
    return (0, s.splitAtTopLevelOnly)(y, ",").every(j => (j = u(j), j.startsWith("var(") ? !0 : j.includes(" ") && !/(['"])([^"']+)\1/g.test(j) || /^\d/g.test(j) ? !1 : (C++, !0))) ? C > 0 : !1;
  }
  let T = /* @__PURE__ */new Set(["serif", "sans-serif", "monospace", "cursive", "fantasy", "system-ui", "ui-serif", "ui-sans-serif", "ui-monospace", "ui-rounded", "math", "emoji", "fangsong"]);
  function g(y) {
    return T.has(y);
  }
  let _ = /* @__PURE__ */new Set(["xx-small", "x-small", "small", "medium", "large", "x-large", "xx-large", "xxx-large"]);
  function E(y) {
    return _.has(y);
  }
  let v = /* @__PURE__ */new Set(["larger", "smaller"]);
  function O(y) {
    return v.has(y);
  }
})(zt);
var Dr = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "backgroundSize", {
    enumerable: !0,
    get: function () {
      return o;
    }
  });
  const t = zt,
    r = lt;
  function o(s) {
    let i = ["cover", "contain"];
    return (0, r.splitAtTopLevelOnly)(s, ",").every(n => {
      let c = (0, r.splitAtTopLevelOnly)(n, "_").filter(Boolean);
      return c.length === 1 && i.includes(c[0]) ? !0 : c.length !== 1 && c.length !== 2 ? !1 : c.every(u => (0, t.length)(u) || (0, t.percentage)(u) || u === "auto");
    });
  }
})(Dr);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(w, A) {
    for (var T in A) Object.defineProperty(w, T, {
      enumerable: !0,
      get: A[T]
    });
  }
  t(e, {
    updateAllClasses: function () {
      return a;
    },
    asValue: function () {
      return p;
    },
    parseColorFormat: function () {
      return x;
    },
    asColor: function () {
      return P;
    },
    asLookupValue: function () {
      return R;
    },
    typeMap: function () {
      return z;
    },
    coerceValue: function () {
      return Y;
    },
    getMatchingTypes: function () {
      return J;
    }
  });
  const r = /* @__PURE__ */u(Pr),
    o = Ft,
    s = zt,
    i = /* @__PURE__ */u(Rt),
    n = Dr,
    c = st;
  function u(w) {
    return w && w.__esModule ? w : {
      default: w
    };
  }
  function a(w, A) {
    w.walkClasses(T => {
      T.value = A(T.value), T.raws && T.raws.value && (T.raws.value = (0, r.default)(T.raws.value));
    });
  }
  function f(w, A) {
    if (!h(w)) return;
    let T = w.slice(1, -1);
    if (A(T)) return (0, s.normalize)(T);
  }
  function d(w) {
    let A = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let T = arguments.length > 2 ? arguments[2] : undefined;
    let g = A[w];
    if (g !== void 0) return (0, i.default)(g);
    if (h(w)) {
      let _ = f(w, T);
      return _ === void 0 ? void 0 : (0, i.default)(_);
    }
  }
  function p(w) {
    let A = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let {
      validate: T = () => !0
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var g;
    let _ = (g = A.values) === null || g === void 0 ? void 0 : g[w];
    return _ !== void 0 ? _ : A.supportsNegativeValues && w.startsWith("-") ? d(w.slice(1), A.values, T) : f(w, T);
  }
  function h(w) {
    return w.startsWith("[") && w.endsWith("]");
  }
  function m(w) {
    let A = w.lastIndexOf("/"),
      T = w.lastIndexOf("[", A),
      g = w.indexOf("]", A);
    return w[A - 1] === "]" || w[A + 1] === "[" || T !== -1 && g !== -1 && T < A && A < g && (A = w.lastIndexOf("/", T)), A === -1 || A === w.length - 1 ? [w, void 0] : h(w) && !w.includes("]/[") ? [w, void 0] : [w.slice(0, A), w.slice(A + 1)];
  }
  function x(w) {
    if (typeof w == "string" && w.includes("<alpha-value>")) {
      let A = w;
      return _ref5 => {
        let {
          opacityValue: T = 1
        } = _ref5;
        return A.replace(/<alpha-value>/g, T);
      };
    }
    return w;
  }
  function k(w) {
    return (0, s.normalize)(w.slice(1, -1));
  }
  function P(w) {
    let A = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let {
      tailwindConfig: T = {}
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var g;
    if (((g = A.values) === null || g === void 0 ? void 0 : g[w]) !== void 0) {
      var _;
      return x((_ = A.values) === null || _ === void 0 ? void 0 : _[w]);
    }
    let [E, v] = m(w);
    if (v !== void 0) {
      var O, y, C, F;
      let j = (F = (O = A.values) === null || O === void 0 ? void 0 : O[E]) !== null && F !== void 0 ? F : h(E) ? E.slice(1, -1) : void 0;
      return j === void 0 ? void 0 : (j = x(j), h(v) ? (0, o.withAlphaValue)(j, k(v)) : ((y = T.theme) === null || y === void 0 || (C = y.opacity) === null || C === void 0 ? void 0 : C[v]) === void 0 ? void 0 : (0, o.withAlphaValue)(j, T.theme.opacity[v]));
    }
    return p(w, A, {
      validate: s.color
    });
  }
  function R(w) {
    let A = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var T;
    return (T = A.values) === null || T === void 0 ? void 0 : T[w];
  }
  function $(w) {
    return (A, T) => p(A, T, {
      validate: w
    });
  }
  let z = {
      any: p,
      color: P,
      url: $(s.url),
      image: $(s.image),
      length: $(s.length),
      percentage: $(s.percentage),
      position: $(s.position),
      lookup: R,
      "generic-name": $(s.genericName),
      "family-name": $(s.familyName),
      number: $(s.number),
      "line-width": $(s.lineWidth),
      "absolute-size": $(s.absoluteSize),
      "relative-size": $(s.relativeSize),
      shadow: $(s.shadow),
      size: $(n.backgroundSize)
    },
    M = Object.keys(z);
  function G(w, A) {
    let T = w.indexOf(A);
    return T === -1 ? [void 0, w] : [w.slice(0, T), w.slice(T + 1)];
  }
  function Y(w, A, T, g) {
    if (T.values && A in T.values) for (let {
      type: E
    } of w !== null && w !== void 0 ? w : []) {
      let v = z[E](A, T, {
        tailwindConfig: g
      });
      if (v !== void 0) return [v, E, null];
    }
    if (h(A)) {
      let E = A.slice(1, -1),
        [v, O] = G(E, ":");
      if (!/^[\w-_]+$/g.test(v)) O = E;else if (v !== void 0 && !M.includes(v)) return [];
      if (O.length > 0 && M.includes(v)) return [p(`[${O}]`, T), v, null];
    }
    let _ = J(w, A, T, g);
    for (let E of _) return E;
    return [];
  }
  function* J(w, A, T, g) {
    let _ = (0, c.flagEnabled)(g, "generalizedModifiers"),
      [E, v] = m(A);
    if (_ && T.modifiers != null && (T.modifiers === "any" || typeof T.modifiers == "object" && (v && h(v) || v in T.modifiers)) || (E = A, v = void 0), v !== void 0 && E === "" && (E = "DEFAULT"), v !== void 0 && typeof T.modifiers == "object") {
      var y, C;
      let F = (C = (y = T.modifiers) === null || y === void 0 ? void 0 : y[v]) !== null && C !== void 0 ? C : null;
      F !== null ? v = F : h(v) && (v = k(v));
    }
    for (let {
      type: F
    } of w !== null && w !== void 0 ? w : []) {
      var _v;
      let j = z[F](E, T, {
        tailwindConfig: g
      });
      j !== void 0 && (yield [j, F, (_v = v) !== null && _v !== void 0 ? _v : null]);
    }
  }
})(Rr);
var zr = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return t;
    }
  });
  function t(r) {
    return typeof r == "function" ? r({}) : r;
  }
})(zr);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return T;
    }
  });
  const t = /* @__PURE__ */h(Rt),
    r = /* @__PURE__ */h(wr),
    o = /* @__PURE__ */h(_r),
    s = /* @__PURE__ */h(Cr),
    i = Sr,
    n = Or,
    c = Ar,
    u = /* @__PURE__ */h(Tr),
    a = jt,
    f = Rr,
    d = Ft,
    p = /* @__PURE__ */h(zr);
  function h(g) {
    return g && g.__esModule ? g : {
      default: g
    };
  }
  function m(g) {
    return typeof g == "function";
  }
  function x(g) {
    for (var _len2 = arguments.length, _ = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      _[_key2 - 1] = arguments[_key2];
    }
    let E = _.pop();
    for (let v of _) for (let O in v) {
      let y = E(g[O], v[O]);
      y === void 0 ? (0, u.default)(g[O]) && (0, u.default)(v[O]) ? g[O] = x({}, g[O], v[O], E) : g[O] = v[O] : g[O] = y;
    }
    return g;
  }
  const k = {
    colors: s.default,
    negative(g) {
      return Object.keys(g).filter(_ => g[_] !== "0").reduce((_, E) => {
        let v = (0, t.default)(g[E]);
        return v !== void 0 && (_[`-${E}`] = v), _;
      }, {});
    },
    breakpoints(g) {
      return Object.keys(g).filter(_ => typeof g[_] == "string").reduce((_, E) => ({
        ..._,
        [`screen-${E}`]: g[E]
      }), {});
    }
  };
  function P(g) {
    for (var _len3 = arguments.length, _ = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      _[_key3 - 1] = arguments[_key3];
    }
    return m(g) ? g(..._) : g;
  }
  function R(g) {
    return g.reduce((_, _ref6) => {
      let {
        extend: E
      } = _ref6;
      return x(_, E, (v, O) => v === void 0 ? [O] : Array.isArray(v) ? [O, ...v] : [O, v]);
    }, {});
  }
  function $(g) {
    return {
      ...g.reduce((_, E) => (0, i.defaults)(_, E), {}),
      // In order to resolve n config objects, we combine all of their `extend` properties
      // into arrays instead of objects so they aren't overridden.
      extend: R(g)
    };
  }
  function z(g, _) {
    if (Array.isArray(g) && (0, u.default)(g[0])) return g.concat(_);
    if (Array.isArray(_) && (0, u.default)(_[0]) && (0, u.default)(g)) return [g, ..._];
    if (Array.isArray(_)) return _;
  }
  function M(_ref7) {
    let {
      extend: g,
      ..._
    } = _ref7;
    return x(_, g, (E, v) => !m(E) && !v.some(m) ? x({}, E, ...v, z) : (O, y) => x({}, ...[E, ...v].map(C => P(C, O, y)), z));
  }
  function* G(g) {
    let _ = (0, n.toPath)(g);
    if (_.length === 0 || (yield _, Array.isArray(g))) return;
    let E = /^(.*?)\s*\/\s*([^/]+)$/,
      v = g.match(E);
    if (v !== null) {
      let [, O, y] = v,
        C = (0, n.toPath)(O);
      C.alpha = y, yield C;
    }
  }
  function Y(g) {
    const _ = (E, v) => {
      for (const O of G(E)) {
        let y = 0,
          C = g;
        for (; C != null && y < O.length;) C = C[O[y++]], C = m(C) && (O.alpha === void 0 || y <= O.length - 1) ? C(_, k) : C;
        if (C !== void 0) {
          if (O.alpha !== void 0) {
            let F = (0, f.parseColorFormat)(C);
            return (0, d.withAlphaValue)(F, O.alpha, (0, p.default)(F));
          }
          return (0, u.default)(C) ? (0, a.cloneDeep)(C) : C;
        }
      }
      return v;
    };
    return Object.assign(_, {
      theme: _,
      ...k
    }), Object.keys(g).reduce((E, v) => (E[v] = m(g[v]) ? g[v](_, k) : g[v], E), {});
  }
  function J(g) {
    let _ = [];
    return g.forEach(E => {
      _ = [..._, E];
      var v;
      const O = (v = E == null ? void 0 : E.plugins) !== null && v !== void 0 ? v : [];
      O.length !== 0 && O.forEach(y => {
        y.__isOptionsFunction && (y = y());
        var C;
        _ = [..._, ...J([(C = y == null ? void 0 : y.config) !== null && C !== void 0 ? C : {}])];
      });
    }), _;
  }
  function w(g) {
    return [...g].reduceRight((E, v) => m(v) ? v({
      corePlugins: E
    }) : (0, o.default)(v, E), r.default);
  }
  function A(g) {
    return [...g].reduceRight((E, v) => [...E, ...v], []);
  }
  function T(g) {
    let _ = [...J(g), {
      prefix: "",
      important: !1,
      separator: ":"
    }];
    var E, v;
    return (0, c.normalizeConfig)((0, i.defaults)({
      theme: Y(M($(_.map(O => (E = O == null ? void 0 : O.theme) !== null && E !== void 0 ? E : {})))),
      corePlugins: w(_.map(O => O.corePlugins)),
      plugins: A(g.map(O => (v = O == null ? void 0 : O.plugins) !== null && v !== void 0 ? v : []))
    }, ..._));
  }
})(vr);
var Lr = {},
  Mr = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: _ref8 => {
        let {
          theme: e
        } = _ref8;
        return {
          ...e("colors"),
          auto: "auto"
        };
      },
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: _ref9 => {
        let {
          theme: e
        } = _ref9;
        return e("blur");
      },
      backdropBrightness: _ref10 => {
        let {
          theme: e
        } = _ref10;
        return e("brightness");
      },
      backdropContrast: _ref11 => {
        let {
          theme: e
        } = _ref11;
        return e("contrast");
      },
      backdropGrayscale: _ref12 => {
        let {
          theme: e
        } = _ref12;
        return e("grayscale");
      },
      backdropHueRotate: _ref13 => {
        let {
          theme: e
        } = _ref13;
        return e("hueRotate");
      },
      backdropInvert: _ref14 => {
        let {
          theme: e
        } = _ref14;
        return e("invert");
      },
      backdropOpacity: _ref15 => {
        let {
          theme: e
        } = _ref15;
        return e("opacity");
      },
      backdropSaturate: _ref16 => {
        let {
          theme: e
        } = _ref16;
        return e("saturate");
      },
      backdropSepia: _ref17 => {
        let {
          theme: e
        } = _ref17;
        return e("sepia");
      },
      backgroundColor: _ref18 => {
        let {
          theme: e
        } = _ref18;
        return e("colors");
      },
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: _ref19 => {
        let {
          theme: e
        } = _ref19;
        return e("opacity");
      },
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: _ref20 => {
        let {
          theme: e
        } = _ref20;
        return {
          ...e("colors"),
          DEFAULT: e("colors.gray.200", "currentColor")
        };
      },
      borderOpacity: _ref21 => {
        let {
          theme: e
        } = _ref21;
        return e("opacity");
      },
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: _ref22 => {
        let {
          theme: e
        } = _ref22;
        return {
          ...e("spacing")
        };
      },
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: _ref23 => {
        let {
          theme: e
        } = _ref23;
        return e("colors");
      },
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: _ref24 => {
        let {
          theme: e
        } = _ref24;
        return e("colors");
      },
      colors: _ref25 => {
        let {
          colors: e
        } = _ref25;
        return {
          inherit: e.inherit,
          current: e.current,
          transparent: e.transparent,
          black: e.black,
          white: e.white,
          slate: e.slate,
          gray: e.gray,
          zinc: e.zinc,
          neutral: e.neutral,
          stone: e.stone,
          red: e.red,
          orange: e.orange,
          amber: e.amber,
          yellow: e.yellow,
          lime: e.lime,
          green: e.green,
          emerald: e.emerald,
          teal: e.teal,
          cyan: e.cyan,
          sky: e.sky,
          blue: e.blue,
          indigo: e.indigo,
          violet: e.violet,
          purple: e.purple,
          fuchsia: e.fuchsia,
          pink: e.pink,
          rose: e.rose
        };
      },
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: _ref26 => {
        let {
          theme: e
        } = _ref26;
        return e("borderColor");
      },
      divideOpacity: _ref27 => {
        let {
          theme: e
        } = _ref27;
        return e("borderOpacity");
      },
      divideWidth: _ref28 => {
        let {
          theme: e
        } = _ref28;
        return e("borderWidth");
      },
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: _ref29 => {
        let {
          theme: e
        } = _ref29;
        return {
          none: "none",
          ...e("colors")
        };
      },
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: _ref30 => {
        let {
          theme: e
        } = _ref30;
        return {
          auto: "auto",
          ...e("spacing"),
          "1/2": "50%",
          "1/3": "33.333333%",
          "2/3": "66.666667%",
          "1/4": "25%",
          "2/4": "50%",
          "3/4": "75%",
          "1/5": "20%",
          "2/5": "40%",
          "3/5": "60%",
          "4/5": "80%",
          "1/6": "16.666667%",
          "2/6": "33.333333%",
          "3/6": "50%",
          "4/6": "66.666667%",
          "5/6": "83.333333%",
          "1/12": "8.333333%",
          "2/12": "16.666667%",
          "3/12": "25%",
          "4/12": "33.333333%",
          "5/12": "41.666667%",
          "6/12": "50%",
          "7/12": "58.333333%",
          "8/12": "66.666667%",
          "9/12": "75%",
          "10/12": "83.333333%",
          "11/12": "91.666667%",
          full: "100%"
        };
      },
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: ["ui-sans-serif", "system-ui", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"', '"Noto Color Emoji"'],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: ["ui-monospace", "SFMono-Regular", "Menlo", "Monaco", "Consolas", '"Liberation Mono"', '"Courier New"', "monospace"]
      },
      fontSize: {
        xs: ["0.75rem", {
          lineHeight: "1rem"
        }],
        sm: ["0.875rem", {
          lineHeight: "1.25rem"
        }],
        base: ["1rem", {
          lineHeight: "1.5rem"
        }],
        lg: ["1.125rem", {
          lineHeight: "1.75rem"
        }],
        xl: ["1.25rem", {
          lineHeight: "1.75rem"
        }],
        "2xl": ["1.5rem", {
          lineHeight: "2rem"
        }],
        "3xl": ["1.875rem", {
          lineHeight: "2.25rem"
        }],
        "4xl": ["2.25rem", {
          lineHeight: "2.5rem"
        }],
        "5xl": ["3rem", {
          lineHeight: "1"
        }],
        "6xl": ["3.75rem", {
          lineHeight: "1"
        }],
        "7xl": ["4.5rem", {
          lineHeight: "1"
        }],
        "8xl": ["6rem", {
          lineHeight: "1"
        }],
        "9xl": ["8rem", {
          lineHeight: "1"
        }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: _ref31 => {
        let {
          theme: e
        } = _ref31;
        return e("spacing");
      },
      gradientColorStops: _ref32 => {
        let {
          theme: e
        } = _ref32;
        return e("colors");
      },
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: _ref33 => {
        let {
          theme: e
        } = _ref33;
        return {
          auto: "auto",
          ...e("spacing"),
          "1/2": "50%",
          "1/3": "33.333333%",
          "2/3": "66.666667%",
          "1/4": "25%",
          "2/4": "50%",
          "3/4": "75%",
          "1/5": "20%",
          "2/5": "40%",
          "3/5": "60%",
          "4/5": "80%",
          "1/6": "16.666667%",
          "2/6": "33.333333%",
          "3/6": "50%",
          "4/6": "66.666667%",
          "5/6": "83.333333%",
          full: "100%",
          screen: "100vh",
          svh: "100svh",
          lvh: "100lvh",
          dvh: "100dvh",
          min: "min-content",
          max: "max-content",
          fit: "fit-content"
        };
      },
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: _ref34 => {
        let {
          theme: e
        } = _ref34;
        return {
          auto: "auto",
          ...e("spacing"),
          "1/2": "50%",
          "1/3": "33.333333%",
          "2/3": "66.666667%",
          "1/4": "25%",
          "2/4": "50%",
          "3/4": "75%",
          full: "100%"
        };
      },
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: _ref35 => {
        let {
          theme: e
        } = _ref35;
        return {
          auto: "auto",
          ...e("spacing")
        };
      },
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: _ref36 => {
        let {
          theme: e
        } = _ref36;
        return {
          ...e("spacing"),
          none: "none",
          full: "100%",
          screen: "100vh",
          svh: "100svh",
          lvh: "100lvh",
          dvh: "100dvh",
          min: "min-content",
          max: "max-content",
          fit: "fit-content"
        };
      },
      maxWidth: _ref37 => {
        let {
          theme: e,
          breakpoints: t
        } = _ref37;
        return {
          ...e("spacing"),
          none: "none",
          xs: "20rem",
          sm: "24rem",
          md: "28rem",
          lg: "32rem",
          xl: "36rem",
          "2xl": "42rem",
          "3xl": "48rem",
          "4xl": "56rem",
          "5xl": "64rem",
          "6xl": "72rem",
          "7xl": "80rem",
          full: "100%",
          min: "min-content",
          max: "max-content",
          fit: "fit-content",
          prose: "65ch",
          ...t(e("screens"))
        };
      },
      minHeight: _ref38 => {
        let {
          theme: e
        } = _ref38;
        return {
          ...e("spacing"),
          full: "100%",
          screen: "100vh",
          svh: "100svh",
          lvh: "100lvh",
          dvh: "100dvh",
          min: "min-content",
          max: "max-content",
          fit: "fit-content"
        };
      },
      minWidth: _ref39 => {
        let {
          theme: e
        } = _ref39;
        return {
          ...e("spacing"),
          full: "100%",
          min: "min-content",
          max: "max-content",
          fit: "fit-content"
        };
      },
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: _ref40 => {
        let {
          theme: e
        } = _ref40;
        return e("colors");
      },
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: _ref41 => {
        let {
          theme: e
        } = _ref41;
        return e("spacing");
      },
      placeholderColor: _ref42 => {
        let {
          theme: e
        } = _ref42;
        return e("colors");
      },
      placeholderOpacity: _ref43 => {
        let {
          theme: e
        } = _ref43;
        return e("opacity");
      },
      ringColor: _ref44 => {
        let {
          theme: e
        } = _ref44;
        return {
          DEFAULT: e("colors.blue.500", "#3b82f6"),
          ...e("colors")
        };
      },
      ringOffsetColor: _ref45 => {
        let {
          theme: e
        } = _ref45;
        return e("colors");
      },
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: _ref46 => {
        let {
          theme: e
        } = _ref46;
        return {
          DEFAULT: "0.5",
          ...e("opacity")
        };
      },
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: _ref47 => {
        let {
          theme: e
        } = _ref47;
        return {
          ...e("spacing")
        };
      },
      scrollPadding: _ref48 => {
        let {
          theme: e
        } = _ref48;
        return e("spacing");
      },
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: _ref49 => {
        let {
          theme: e
        } = _ref49;
        return {
          ...e("spacing")
        };
      },
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: _ref50 => {
        let {
          theme: e
        } = _ref50;
        return {
          none: "none",
          ...e("colors")
        };
      },
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: _ref51 => {
        let {
          theme: e
        } = _ref51;
        return e("colors");
      },
      textDecorationColor: _ref52 => {
        let {
          theme: e
        } = _ref52;
        return e("colors");
      },
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: _ref53 => {
        let {
          theme: e
        } = _ref53;
        return {
          ...e("spacing")
        };
      },
      textOpacity: _ref54 => {
        let {
          theme: e
        } = _ref54;
        return e("opacity");
      },
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: _ref55 => {
        let {
          theme: e
        } = _ref55;
        return {
          ...e("spacing"),
          "1/2": "50%",
          "1/3": "33.333333%",
          "2/3": "66.666667%",
          "1/4": "25%",
          "2/4": "50%",
          "3/4": "75%",
          full: "100%"
        };
      },
      size: _ref56 => {
        let {
          theme: e
        } = _ref56;
        return {
          auto: "auto",
          ...e("spacing"),
          "1/2": "50%",
          "1/3": "33.333333%",
          "2/3": "66.666667%",
          "1/4": "25%",
          "2/4": "50%",
          "3/4": "75%",
          "1/5": "20%",
          "2/5": "40%",
          "3/5": "60%",
          "4/5": "80%",
          "1/6": "16.666667%",
          "2/6": "33.333333%",
          "3/6": "50%",
          "4/6": "66.666667%",
          "5/6": "83.333333%",
          "1/12": "8.333333%",
          "2/12": "16.666667%",
          "3/12": "25%",
          "4/12": "33.333333%",
          "5/12": "41.666667%",
          "6/12": "50%",
          "7/12": "58.333333%",
          "8/12": "66.666667%",
          "9/12": "75%",
          "10/12": "83.333333%",
          "11/12": "91.666667%",
          full: "100%",
          min: "min-content",
          max: "max-content",
          fit: "fit-content"
        };
      },
      width: _ref57 => {
        let {
          theme: e
        } = _ref57;
        return {
          auto: "auto",
          ...e("spacing"),
          "1/2": "50%",
          "1/3": "33.333333%",
          "2/3": "66.666667%",
          "1/4": "25%",
          "2/4": "50%",
          "3/4": "75%",
          "1/5": "20%",
          "2/5": "40%",
          "3/5": "60%",
          "4/5": "80%",
          "1/6": "16.666667%",
          "2/6": "33.333333%",
          "3/6": "50%",
          "4/6": "66.666667%",
          "5/6": "83.333333%",
          "1/12": "8.333333%",
          "2/12": "16.666667%",
          "3/12": "25%",
          "4/12": "33.333333%",
          "5/12": "41.666667%",
          "6/12": "50%",
          "7/12": "58.333333%",
          "8/12": "66.666667%",
          "9/12": "75%",
          "10/12": "83.333333%",
          "11/12": "91.666667%",
          full: "100%",
          screen: "100vw",
          svw: "100svw",
          lvw: "100lvw",
          dvw: "100dvw",
          min: "min-content",
          max: "max-content",
          fit: "fit-content"
        };
      },
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  };
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return s;
    }
  });
  const t = /* @__PURE__ */o(Mr),
    r = st;
  function o(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  function s(i) {
    var n;
    const c = ((n = i == null ? void 0 : i.presets) !== null && n !== void 0 ? n : [t.default]).slice().reverse().flatMap(f => s(f instanceof Function ? f() : f)),
      u = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
          theme: {
            ringColor: _ref58 => {
              let {
                theme: f
              } = _ref58;
              return {
                DEFAULT: "#3b82f67f",
                ...f("colors")
              };
            }
          }
        },
        disableColorOpacityUtilitiesByDefault: {
          corePlugins: {
            backgroundOpacity: !1,
            borderOpacity: !1,
            divideOpacity: !1,
            placeholderOpacity: !1,
            ringOpacity: !1,
            textOpacity: !1
          }
        }
      },
      a = Object.keys(u).filter(f => (0, r.flagEnabled)(i, f)).map(f => u[f]);
    return [i, ...a, ...c];
  }
})(Lr);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return s;
    }
  });
  const t = /* @__PURE__ */o(vr),
    r = /* @__PURE__ */o(Lr);
  function o(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  function s() {
    for (var _len4 = arguments.length, i = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      i[_key4] = arguments[_key4];
    }
    let [, ...n] = (0, r.default)(i[0]);
    return (0, t.default)([...i, ...n]);
  }
})(xr);
let yt = xr;
var Hn = (yt.__esModule ? yt : {
  default: yt
}).default;
const Gn = /* @__PURE__ */yr(Hn),
  $r = {
    primary: "#f09242",
    "primary-3": "#f0924208",
    "primary-5": "#f092420D",
    "primary-10": "#f092421A",
    "primary-20": "#f0924233",
    "primary-30": "#f092424D",
    white: "#FFFFFF",
    "white-3": "#FFFFFF08",
    "white-5": "#FFFFFF0D",
    "white-10": "#FFFFFF1A",
    "white-20": "#FFFFFF33",
    "white-30": "#FFFFFF4D",
    regular: "#ABABAB",
    // TODO Rename when color added to design system
    "regular-fa": "#FAFAFA",
    success: "#71DD5F",
    "success-3": "#71DD5F08",
    "success-5": "#71DD5F0D",
    "success-10": "#71DD5F1A",
    "success-20": "#71DD5F33",
    "success-30": "#71DD5F4D",
    warning: "#FDAC5D",
    "warning-3": "#FDAC5D08",
    "warning-5": "#FDAC5D08",
    "warning-10": "#FDAC5D1A",
    "warning-20": "#FDAC5D33",
    "warning-30": "#FDAC5D4D",
    error: "#E44E45",
    "error-3": "#E44E4508",
    "error-5": "#E44E450D",
    "error-10": "#E44E451A",
    "error-20": "#E44E4533",
    "error-30": "#E44E454D",
    "black-0": "#0c0c0d",
    "black-1": "#121214",
    "black-2": "#18181a",
    "black-3": "#242426",
    "black-4": "#2A2B30"
  },
  Nr = {
    m16: ["16px", {
      lineHeight: "24px",
      fontWeight: "500"
    }],
    m15: ["15px", {
      lineHeight: "24px",
      fontWeight: "500"
    }],
    m14: ["14px", {
      lineHeight: "20px",
      fontWeight: "500"
    }],
    m13: ["13px", {
      lineHeight: "20px",
      fontWeight: "500"
    }],
    m12: ["12px", {
      lineHeight: "20px",
      fontWeight: "500"
    }],
    r24: ["24px", {
      lineHeight: "32px",
      fontWeight: "400"
    }],
    r20: ["20px", {
      lineHeight: "32px",
      fontWeight: "400"
    }],
    r16: ["16px", {
      lineHeight: "28px",
      fontWeight: "400"
    }],
    r14: ["14px", {
      lineHeight: "24px",
      fontWeight: "400"
    }],
    r13: ["13px", {
      lineHeight: "24px",
      fontWeight: "400"
    }],
    r12: ["12px", {
      lineHeight: "20px",
      fontWeight: "400"
    }]
  };
var Wr = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function () {
      return s;
    }
  });
  const t = jt,
    r = /* @__PURE__ */o(Mr);
  function o(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  const s = (0, t.cloneDeep)(r.default.theme);
})(Wr);
let xt = Wr;
var qn = (xt.__esModule ? xt : {
  default: xt
}).default;
const Yn = {
    content: ["./src/**/*.{js,jsx,ts,tsx}", "./.storybook/**/*.{js,jsx,ts,tsx}"],
    theme: {
      spacing: {
        0: "0px",
        4: "4px",
        8: "8px",
        12: "12px",
        16: "16px",
        20: "20px",
        24: "24px",
        28: "28px",
        32: "32px",
        36: "36px",
        40: "40px",
        44: "44px",
        48: "48px",
        52: "52px",
        56: "56px",
        60: "60px",
        64: "64px",
        68: "68px",
        72: "72px",
        76: "76px",
        80: "80px",
        84: "84px",
        88: "88px",
        92: "92px",
        96: "96px",
        100: "100px"
      },
      colors: $r,
      fontSize: Nr,
      fontFamily: {
        openSauce1: ["Open Sauce One", ...qn.fontFamily.serif]
      },
      boxShadow: {
        tooltip: "0px 8px 25px 0px rgba(40, 40, 40, 0.60), 0px 4px 8px 0px rgba(0, 0, 0, 0.40)"
      }
    },
    plugins: []
  },
  Kn = Gn(Yn),
  {
    theme: {
      screens: Xn
    }
  } = Kn,
  Jn = e => {
    const t = `(max-width: ${Xn[e]})`,
      r = window.matchMedia(t),
      [o, s] = ot(!1),
      i = n => s(n.matches);
    return it(() => (s(r.matches), r.addEventListener("change", i), () => r.removeEventListener("change", i)), [e]), o;
  };
var Br = {
  exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function (e) {
  (function () {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", n = 0; n < arguments.length; n++) {
        var c = arguments[n];
        c && (i = s(i, o(c)));
      }
      return i;
    }
    function o(i) {
      if (typeof i == "string" || typeof i == "number") return i;
      if (typeof i != "object") return "";
      if (Array.isArray(i)) return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) return i.toString();
      var n = "";
      for (var c in i) t.call(i, c) && i[c] && (n = s(n, c));
      return n;
    }
    function s(i, n) {
      return n ? i ? i + " " + n : i + n : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Br);
var Zn = Br.exports;
const ce = /* @__PURE__ */yr(Zn),
  Lt = "-",
  Qn = e => {
    const t = to(e),
      {
        conflictingClassGroups: r,
        conflictingClassGroupModifiers: o
      } = e;
    return {
      getClassGroupId: n => {
        const c = n.split(Lt);
        return c[0] === "" && c.length !== 1 && c.shift(), Ir(c, t) || eo(n);
      },
      getConflictingClassGroupIds: (n, c) => {
        const u = r[n] || [];
        return c && o[n] ? [...u, ...o[n]] : u;
      }
    };
  },
  Ir = (e, t) => {
    var n;
    if (e.length === 0) return t.classGroupId;
    const r = e[0],
      o = t.nextPart.get(r),
      s = o ? Ir(e.slice(1), o) : void 0;
    if (s) return s;
    if (t.validators.length === 0) return;
    const i = e.join(Lt);
    return (n = t.validators.find(_ref59 => {
      let {
        validator: c
      } = _ref59;
      return c(i);
    })) == null ? void 0 : n.classGroupId;
  },
  nr = /^\[(.+)\]$/,
  eo = e => {
    if (nr.test(e)) {
      const t = nr.exec(e)[1],
        r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
      if (r) return "arbitrary.." + r;
    }
  },
  to = e => {
    const {
        theme: t,
        prefix: r
      } = e,
      o = {
        nextPart: /* @__PURE__ */new Map(),
        validators: []
      };
    return no(Object.entries(e.classGroups), r).forEach(_ref60 => {
      let [i, n] = _ref60;
      At(n, o, i, t);
    }), o;
  },
  At = (e, t, r, o) => {
    e.forEach(s => {
      if (typeof s == "string") {
        const i = s === "" ? t : or(t, s);
        i.classGroupId = r;
        return;
      }
      if (typeof s == "function") {
        if (ro(s)) {
          At(s(o), t, r, o);
          return;
        }
        t.validators.push({
          validator: s,
          classGroupId: r
        });
        return;
      }
      Object.entries(s).forEach(_ref61 => {
        let [i, n] = _ref61;
        At(n, or(t, i), r, o);
      });
    });
  },
  or = (e, t) => {
    let r = e;
    return t.split(Lt).forEach(o => {
      r.nextPart.has(o) || r.nextPart.set(o, {
        nextPart: /* @__PURE__ */new Map(),
        validators: []
      }), r = r.nextPart.get(o);
    }), r;
  },
  ro = e => e.isThemeGetter,
  no = (e, t) => t ? e.map(_ref62 => {
    let [r, o] = _ref62;
    const s = o.map(i => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(_ref63 => {
      let [n, c] = _ref63;
      return [t + n, c];
    })) : i);
    return [r, s];
  }) : e,
  oo = e => {
    if (e < 1) return {
      get: () => {},
      set: () => {}
    };
    let t = 0,
      r = /* @__PURE__ */new Map(),
      o = /* @__PURE__ */new Map();
    const s = (i, n) => {
      r.set(i, n), t++, t > e && (t = 0, o = r, r = /* @__PURE__ */new Map());
    };
    return {
      get(i) {
        let n = r.get(i);
        if (n !== void 0) return n;
        if ((n = o.get(i)) !== void 0) return s(i, n), n;
      },
      set(i, n) {
        r.has(i) ? r.set(i, n) : s(i, n);
      }
    };
  },
  Vr = "!",
  io = e => {
    const {
        separator: t,
        experimentalParseClassName: r
      } = e,
      o = t.length === 1,
      s = t[0],
      i = t.length,
      n = c => {
        const u = [];
        let a = 0,
          f = 0,
          d;
        for (let k = 0; k < c.length; k++) {
          let P = c[k];
          if (a === 0) {
            if (P === s && (o || c.slice(k, k + i) === t)) {
              u.push(c.slice(f, k)), f = k + i;
              continue;
            }
            if (P === "/") {
              d = k;
              continue;
            }
          }
          P === "[" ? a++ : P === "]" && a--;
        }
        const p = u.length === 0 ? c : c.substring(f),
          h = p.startsWith(Vr),
          m = h ? p.substring(1) : p,
          x = d && d > f ? d - f : void 0;
        return {
          modifiers: u,
          hasImportantModifier: h,
          baseClassName: m,
          maybePostfixModifierPosition: x
        };
      };
    return r ? c => r({
      className: c,
      parseClassName: n
    }) : n;
  },
  ao = e => {
    if (e.length <= 1) return e;
    const t = [];
    let r = [];
    return e.forEach(o => {
      o[0] === "[" ? (t.push(...r.sort(), o), r = []) : r.push(o);
    }), t.push(...r.sort()), t;
  },
  so = e => ({
    cache: oo(e.cacheSize),
    parseClassName: io(e),
    ...Qn(e)
  }),
  lo = /\s+/,
  co = (e, t) => {
    const {
        parseClassName: r,
        getClassGroupId: o,
        getConflictingClassGroupIds: s
      } = t,
      i = [],
      n = e.trim().split(lo);
    let c = "";
    for (let u = n.length - 1; u >= 0; u -= 1) {
      const a = n[u],
        {
          modifiers: f,
          hasImportantModifier: d,
          baseClassName: p,
          maybePostfixModifierPosition: h
        } = r(a);
      let m = !!h,
        x = o(m ? p.substring(0, h) : p);
      if (!x) {
        if (!m) {
          c = a + (c.length > 0 ? " " + c : c);
          continue;
        }
        if (x = o(p), !x) {
          c = a + (c.length > 0 ? " " + c : c);
          continue;
        }
        m = !1;
      }
      const k = ao(f).join(":"),
        P = d ? k + Vr : k,
        R = P + x;
      if (i.includes(R)) continue;
      i.push(R);
      const $ = s(x, m);
      for (let z = 0; z < $.length; ++z) {
        const M = $[z];
        i.push(P + M);
      }
      c = a + (c.length > 0 ? " " + c : c);
    }
    return c;
  };
function uo() {
  let e = 0,
    t,
    r,
    o = "";
  for (; e < arguments.length;) (t = arguments[e++]) && (r = Ur(t)) && (o && (o += " "), o += r);
  return o;
}
const Ur = e => {
  if (typeof e == "string") return e;
  let t,
    r = "";
  for (let o = 0; o < e.length; o++) e[o] && (t = Ur(e[o])) && (r && (r += " "), r += t);
  return r;
};
function ir(e) {
  for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    t[_key5 - 1] = arguments[_key5];
  }
  let r,
    o,
    s,
    i = n;
  function n(u) {
    const a = t.reduce((f, d) => d(f), e());
    return r = so(a), o = r.cache.get, s = r.cache.set, i = c, c(u);
  }
  function c(u) {
    const a = o(u);
    if (a) return a;
    const f = co(u, r);
    return s(u, f), f;
  }
  return function () {
    return i(uo.apply(null, arguments));
  };
}
const q = e => {
    const t = r => r[e] || [];
    return t.isThemeGetter = !0, t;
  },
  Hr = /^\[(?:([a-z-]+):)?(.+)\]$/i,
  fo = /^\d+\/\d+$/,
  po = /* @__PURE__ */new Set(["px", "full", "screen"]),
  go = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/,
  mo = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/,
  ho = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/,
  bo = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/,
  yo = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/,
  ge = e => Fe(e) || po.has(e) || fo.test(e),
  ye = e => Le(e, "length", So),
  Fe = e => !!e && !Number.isNaN(Number(e)),
  vt = e => Le(e, "number", Fe),
  Ve = e => !!e && Number.isInteger(Number(e)),
  xo = e => e.endsWith("%") && Fe(e.slice(0, -1)),
  W = e => Hr.test(e),
  xe = e => go.test(e),
  vo = /* @__PURE__ */new Set(["length", "size", "percentage"]),
  wo = e => Le(e, vo, Gr),
  _o = e => Le(e, "position", Gr),
  Co = /* @__PURE__ */new Set(["image", "url"]),
  ko = e => Le(e, Co, Ao),
  Eo = e => Le(e, "", Oo),
  Ue = () => !0,
  Le = (e, t, r) => {
    const o = Hr.exec(e);
    return o ? o[1] ? typeof t == "string" ? o[1] === t : t.has(o[1]) : r(o[2]) : !1;
  },
  So = e =>
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  mo.test(e) && !ho.test(e),
  Gr = () => !1,
  Oo = e => bo.test(e),
  Ao = e => yo.test(e),
  ar = () => {
    const e = q("colors"),
      t = q("spacing"),
      r = q("blur"),
      o = q("brightness"),
      s = q("borderColor"),
      i = q("borderRadius"),
      n = q("borderSpacing"),
      c = q("borderWidth"),
      u = q("contrast"),
      a = q("grayscale"),
      f = q("hueRotate"),
      d = q("invert"),
      p = q("gap"),
      h = q("gradientColorStops"),
      m = q("gradientColorStopPositions"),
      x = q("inset"),
      k = q("margin"),
      P = q("opacity"),
      R = q("padding"),
      $ = q("saturate"),
      z = q("scale"),
      M = q("sepia"),
      G = q("skew"),
      Y = q("space"),
      J = q("translate"),
      w = () => ["auto", "contain", "none"],
      A = () => ["auto", "hidden", "clip", "visible", "scroll"],
      T = () => ["auto", W, t],
      g = () => [W, t],
      _ = () => ["", ge, ye],
      E = () => ["auto", Fe, W],
      v = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"],
      O = () => ["solid", "dashed", "dotted", "double", "none"],
      y = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"],
      C = () => ["start", "end", "center", "between", "around", "evenly", "stretch"],
      F = () => ["", "0", W],
      j = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"],
      U = () => [Fe, W];
    return {
      cacheSize: 500,
      separator: ":",
      theme: {
        colors: [Ue],
        spacing: [ge, ye],
        blur: ["none", "", xe, W],
        brightness: U(),
        borderColor: [e],
        borderRadius: ["none", "", "full", xe, W],
        borderSpacing: g(),
        borderWidth: _(),
        contrast: U(),
        grayscale: F(),
        hueRotate: U(),
        invert: F(),
        gap: g(),
        gradientColorStops: [e],
        gradientColorStopPositions: [xo, ye],
        inset: T(),
        margin: T(),
        opacity: U(),
        padding: g(),
        saturate: U(),
        scale: U(),
        sepia: F(),
        skew: U(),
        space: g(),
        translate: g()
      },
      classGroups: {
        // Layout
        /**
         * Aspect Ratio
         * @see https://tailwindcss.com/docs/aspect-ratio
         */
        aspect: [{
          aspect: ["auto", "square", "video", W]
        }],
        /**
         * Container
         * @see https://tailwindcss.com/docs/container
         */
        container: ["container"],
        /**
         * Columns
         * @see https://tailwindcss.com/docs/columns
         */
        columns: [{
          columns: [xe]
        }],
        /**
         * Break After
         * @see https://tailwindcss.com/docs/break-after
         */
        "break-after": [{
          "break-after": j()
        }],
        /**
         * Break Before
         * @see https://tailwindcss.com/docs/break-before
         */
        "break-before": [{
          "break-before": j()
        }],
        /**
         * Break Inside
         * @see https://tailwindcss.com/docs/break-inside
         */
        "break-inside": [{
          "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
        }],
        /**
         * Box Decoration Break
         * @see https://tailwindcss.com/docs/box-decoration-break
         */
        "box-decoration": [{
          "box-decoration": ["slice", "clone"]
        }],
        /**
         * Box Sizing
         * @see https://tailwindcss.com/docs/box-sizing
         */
        box: [{
          box: ["border", "content"]
        }],
        /**
         * Display
         * @see https://tailwindcss.com/docs/display
         */
        display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
        /**
         * Floats
         * @see https://tailwindcss.com/docs/float
         */
        float: [{
          float: ["right", "left", "none", "start", "end"]
        }],
        /**
         * Clear
         * @see https://tailwindcss.com/docs/clear
         */
        clear: [{
          clear: ["left", "right", "both", "none", "start", "end"]
        }],
        /**
         * Isolation
         * @see https://tailwindcss.com/docs/isolation
         */
        isolation: ["isolate", "isolation-auto"],
        /**
         * Object Fit
         * @see https://tailwindcss.com/docs/object-fit
         */
        "object-fit": [{
          object: ["contain", "cover", "fill", "none", "scale-down"]
        }],
        /**
         * Object Position
         * @see https://tailwindcss.com/docs/object-position
         */
        "object-position": [{
          object: [...v(), W]
        }],
        /**
         * Overflow
         * @see https://tailwindcss.com/docs/overflow
         */
        overflow: [{
          overflow: A()
        }],
        /**
         * Overflow X
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-x": [{
          "overflow-x": A()
        }],
        /**
         * Overflow Y
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-y": [{
          "overflow-y": A()
        }],
        /**
         * Overscroll Behavior
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        overscroll: [{
          overscroll: w()
        }],
        /**
         * Overscroll Behavior X
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-x": [{
          "overscroll-x": w()
        }],
        /**
         * Overscroll Behavior Y
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-y": [{
          "overscroll-y": w()
        }],
        /**
         * Position
         * @see https://tailwindcss.com/docs/position
         */
        position: ["static", "fixed", "absolute", "relative", "sticky"],
        /**
         * Top / Right / Bottom / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        inset: [{
          inset: [x]
        }],
        /**
         * Right / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-x": [{
          "inset-x": [x]
        }],
        /**
         * Top / Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-y": [{
          "inset-y": [x]
        }],
        /**
         * Start
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        start: [{
          start: [x]
        }],
        /**
         * End
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        end: [{
          end: [x]
        }],
        /**
         * Top
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        top: [{
          top: [x]
        }],
        /**
         * Right
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        right: [{
          right: [x]
        }],
        /**
         * Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        bottom: [{
          bottom: [x]
        }],
        /**
         * Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        left: [{
          left: [x]
        }],
        /**
         * Visibility
         * @see https://tailwindcss.com/docs/visibility
         */
        visibility: ["visible", "invisible", "collapse"],
        /**
         * Z-Index
         * @see https://tailwindcss.com/docs/z-index
         */
        z: [{
          z: ["auto", Ve, W]
        }],
        // Flexbox and Grid
        /**
         * Flex Basis
         * @see https://tailwindcss.com/docs/flex-basis
         */
        basis: [{
          basis: T()
        }],
        /**
         * Flex Direction
         * @see https://tailwindcss.com/docs/flex-direction
         */
        "flex-direction": [{
          flex: ["row", "row-reverse", "col", "col-reverse"]
        }],
        /**
         * Flex Wrap
         * @see https://tailwindcss.com/docs/flex-wrap
         */
        "flex-wrap": [{
          flex: ["wrap", "wrap-reverse", "nowrap"]
        }],
        /**
         * Flex
         * @see https://tailwindcss.com/docs/flex
         */
        flex: [{
          flex: ["1", "auto", "initial", "none", W]
        }],
        /**
         * Flex Grow
         * @see https://tailwindcss.com/docs/flex-grow
         */
        grow: [{
          grow: F()
        }],
        /**
         * Flex Shrink
         * @see https://tailwindcss.com/docs/flex-shrink
         */
        shrink: [{
          shrink: F()
        }],
        /**
         * Order
         * @see https://tailwindcss.com/docs/order
         */
        order: [{
          order: ["first", "last", "none", Ve, W]
        }],
        /**
         * Grid Template Columns
         * @see https://tailwindcss.com/docs/grid-template-columns
         */
        "grid-cols": [{
          "grid-cols": [Ue]
        }],
        /**
         * Grid Column Start / End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start-end": [{
          col: ["auto", {
            span: ["full", Ve, W]
          }, W]
        }],
        /**
         * Grid Column Start
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start": [{
          "col-start": E()
        }],
        /**
         * Grid Column End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-end": [{
          "col-end": E()
        }],
        /**
         * Grid Template Rows
         * @see https://tailwindcss.com/docs/grid-template-rows
         */
        "grid-rows": [{
          "grid-rows": [Ue]
        }],
        /**
         * Grid Row Start / End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start-end": [{
          row: ["auto", {
            span: [Ve, W]
          }, W]
        }],
        /**
         * Grid Row Start
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start": [{
          "row-start": E()
        }],
        /**
         * Grid Row End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-end": [{
          "row-end": E()
        }],
        /**
         * Grid Auto Flow
         * @see https://tailwindcss.com/docs/grid-auto-flow
         */
        "grid-flow": [{
          "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
        }],
        /**
         * Grid Auto Columns
         * @see https://tailwindcss.com/docs/grid-auto-columns
         */
        "auto-cols": [{
          "auto-cols": ["auto", "min", "max", "fr", W]
        }],
        /**
         * Grid Auto Rows
         * @see https://tailwindcss.com/docs/grid-auto-rows
         */
        "auto-rows": [{
          "auto-rows": ["auto", "min", "max", "fr", W]
        }],
        /**
         * Gap
         * @see https://tailwindcss.com/docs/gap
         */
        gap: [{
          gap: [p]
        }],
        /**
         * Gap X
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-x": [{
          "gap-x": [p]
        }],
        /**
         * Gap Y
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-y": [{
          "gap-y": [p]
        }],
        /**
         * Justify Content
         * @see https://tailwindcss.com/docs/justify-content
         */
        "justify-content": [{
          justify: ["normal", ...C()]
        }],
        /**
         * Justify Items
         * @see https://tailwindcss.com/docs/justify-items
         */
        "justify-items": [{
          "justify-items": ["start", "end", "center", "stretch"]
        }],
        /**
         * Justify Self
         * @see https://tailwindcss.com/docs/justify-self
         */
        "justify-self": [{
          "justify-self": ["auto", "start", "end", "center", "stretch"]
        }],
        /**
         * Align Content
         * @see https://tailwindcss.com/docs/align-content
         */
        "align-content": [{
          content: ["normal", ...C(), "baseline"]
        }],
        /**
         * Align Items
         * @see https://tailwindcss.com/docs/align-items
         */
        "align-items": [{
          items: ["start", "end", "center", "baseline", "stretch"]
        }],
        /**
         * Align Self
         * @see https://tailwindcss.com/docs/align-self
         */
        "align-self": [{
          self: ["auto", "start", "end", "center", "stretch", "baseline"]
        }],
        /**
         * Place Content
         * @see https://tailwindcss.com/docs/place-content
         */
        "place-content": [{
          "place-content": [...C(), "baseline"]
        }],
        /**
         * Place Items
         * @see https://tailwindcss.com/docs/place-items
         */
        "place-items": [{
          "place-items": ["start", "end", "center", "baseline", "stretch"]
        }],
        /**
         * Place Self
         * @see https://tailwindcss.com/docs/place-self
         */
        "place-self": [{
          "place-self": ["auto", "start", "end", "center", "stretch"]
        }],
        // Spacing
        /**
         * Padding
         * @see https://tailwindcss.com/docs/padding
         */
        p: [{
          p: [R]
        }],
        /**
         * Padding X
         * @see https://tailwindcss.com/docs/padding
         */
        px: [{
          px: [R]
        }],
        /**
         * Padding Y
         * @see https://tailwindcss.com/docs/padding
         */
        py: [{
          py: [R]
        }],
        /**
         * Padding Start
         * @see https://tailwindcss.com/docs/padding
         */
        ps: [{
          ps: [R]
        }],
        /**
         * Padding End
         * @see https://tailwindcss.com/docs/padding
         */
        pe: [{
          pe: [R]
        }],
        /**
         * Padding Top
         * @see https://tailwindcss.com/docs/padding
         */
        pt: [{
          pt: [R]
        }],
        /**
         * Padding Right
         * @see https://tailwindcss.com/docs/padding
         */
        pr: [{
          pr: [R]
        }],
        /**
         * Padding Bottom
         * @see https://tailwindcss.com/docs/padding
         */
        pb: [{
          pb: [R]
        }],
        /**
         * Padding Left
         * @see https://tailwindcss.com/docs/padding
         */
        pl: [{
          pl: [R]
        }],
        /**
         * Margin
         * @see https://tailwindcss.com/docs/margin
         */
        m: [{
          m: [k]
        }],
        /**
         * Margin X
         * @see https://tailwindcss.com/docs/margin
         */
        mx: [{
          mx: [k]
        }],
        /**
         * Margin Y
         * @see https://tailwindcss.com/docs/margin
         */
        my: [{
          my: [k]
        }],
        /**
         * Margin Start
         * @see https://tailwindcss.com/docs/margin
         */
        ms: [{
          ms: [k]
        }],
        /**
         * Margin End
         * @see https://tailwindcss.com/docs/margin
         */
        me: [{
          me: [k]
        }],
        /**
         * Margin Top
         * @see https://tailwindcss.com/docs/margin
         */
        mt: [{
          mt: [k]
        }],
        /**
         * Margin Right
         * @see https://tailwindcss.com/docs/margin
         */
        mr: [{
          mr: [k]
        }],
        /**
         * Margin Bottom
         * @see https://tailwindcss.com/docs/margin
         */
        mb: [{
          mb: [k]
        }],
        /**
         * Margin Left
         * @see https://tailwindcss.com/docs/margin
         */
        ml: [{
          ml: [k]
        }],
        /**
         * Space Between X
         * @see https://tailwindcss.com/docs/space
         */
        "space-x": [{
          "space-x": [Y]
        }],
        /**
         * Space Between X Reverse
         * @see https://tailwindcss.com/docs/space
         */
        "space-x-reverse": ["space-x-reverse"],
        /**
         * Space Between Y
         * @see https://tailwindcss.com/docs/space
         */
        "space-y": [{
          "space-y": [Y]
        }],
        /**
         * Space Between Y Reverse
         * @see https://tailwindcss.com/docs/space
         */
        "space-y-reverse": ["space-y-reverse"],
        // Sizing
        /**
         * Width
         * @see https://tailwindcss.com/docs/width
         */
        w: [{
          w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", W, t]
        }],
        /**
         * Min-Width
         * @see https://tailwindcss.com/docs/min-width
         */
        "min-w": [{
          "min-w": [W, t, "min", "max", "fit"]
        }],
        /**
         * Max-Width
         * @see https://tailwindcss.com/docs/max-width
         */
        "max-w": [{
          "max-w": [W, t, "none", "full", "min", "max", "fit", "prose", {
            screen: [xe]
          }, xe]
        }],
        /**
         * Height
         * @see https://tailwindcss.com/docs/height
         */
        h: [{
          h: [W, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        /**
         * Min-Height
         * @see https://tailwindcss.com/docs/min-height
         */
        "min-h": [{
          "min-h": [W, t, "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        /**
         * Max-Height
         * @see https://tailwindcss.com/docs/max-height
         */
        "max-h": [{
          "max-h": [W, t, "min", "max", "fit", "svh", "lvh", "dvh"]
        }],
        /**
         * Size
         * @see https://tailwindcss.com/docs/size
         */
        size: [{
          size: [W, t, "auto", "min", "max", "fit"]
        }],
        // Typography
        /**
         * Font Size
         * @see https://tailwindcss.com/docs/font-size
         */
        "font-size": [{
          text: ["base", xe, ye]
        }],
        /**
         * Font Smoothing
         * @see https://tailwindcss.com/docs/font-smoothing
         */
        "font-smoothing": ["antialiased", "subpixel-antialiased"],
        /**
         * Font Style
         * @see https://tailwindcss.com/docs/font-style
         */
        "font-style": ["italic", "not-italic"],
        /**
         * Font Weight
         * @see https://tailwindcss.com/docs/font-weight
         */
        "font-weight": [{
          font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", vt]
        }],
        /**
         * Font Family
         * @see https://tailwindcss.com/docs/font-family
         */
        "font-family": [{
          font: [Ue]
        }],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-normal": ["normal-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-ordinal": ["ordinal"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-slashed-zero": ["slashed-zero"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-figure": ["lining-nums", "oldstyle-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-spacing": ["proportional-nums", "tabular-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
        /**
         * Letter Spacing
         * @see https://tailwindcss.com/docs/letter-spacing
         */
        tracking: [{
          tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", W]
        }],
        /**
         * Line Clamp
         * @see https://tailwindcss.com/docs/line-clamp
         */
        "line-clamp": [{
          "line-clamp": ["none", Fe, vt]
        }],
        /**
         * Line Height
         * @see https://tailwindcss.com/docs/line-height
         */
        leading: [{
          leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ge, W]
        }],
        /**
         * List Style Image
         * @see https://tailwindcss.com/docs/list-style-image
         */
        "list-image": [{
          "list-image": ["none", W]
        }],
        /**
         * List Style Type
         * @see https://tailwindcss.com/docs/list-style-type
         */
        "list-style-type": [{
          list: ["none", "disc", "decimal", W]
        }],
        /**
         * List Style Position
         * @see https://tailwindcss.com/docs/list-style-position
         */
        "list-style-position": [{
          list: ["inside", "outside"]
        }],
        /**
         * Placeholder Color
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/placeholder-color
         */
        "placeholder-color": [{
          placeholder: [e]
        }],
        /**
         * Placeholder Opacity
         * @see https://tailwindcss.com/docs/placeholder-opacity
         */
        "placeholder-opacity": [{
          "placeholder-opacity": [P]
        }],
        /**
         * Text Alignment
         * @see https://tailwindcss.com/docs/text-align
         */
        "text-alignment": [{
          text: ["left", "center", "right", "justify", "start", "end"]
        }],
        /**
         * Text Color
         * @see https://tailwindcss.com/docs/text-color
         */
        "text-color": [{
          text: [e]
        }],
        /**
         * Text Opacity
         * @see https://tailwindcss.com/docs/text-opacity
         */
        "text-opacity": [{
          "text-opacity": [P]
        }],
        /**
         * Text Decoration
         * @see https://tailwindcss.com/docs/text-decoration
         */
        "text-decoration": ["underline", "overline", "line-through", "no-underline"],
        /**
         * Text Decoration Style
         * @see https://tailwindcss.com/docs/text-decoration-style
         */
        "text-decoration-style": [{
          decoration: [...O(), "wavy"]
        }],
        /**
         * Text Decoration Thickness
         * @see https://tailwindcss.com/docs/text-decoration-thickness
         */
        "text-decoration-thickness": [{
          decoration: ["auto", "from-font", ge, ye]
        }],
        /**
         * Text Underline Offset
         * @see https://tailwindcss.com/docs/text-underline-offset
         */
        "underline-offset": [{
          "underline-offset": ["auto", ge, W]
        }],
        /**
         * Text Decoration Color
         * @see https://tailwindcss.com/docs/text-decoration-color
         */
        "text-decoration-color": [{
          decoration: [e]
        }],
        /**
         * Text Transform
         * @see https://tailwindcss.com/docs/text-transform
         */
        "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
        /**
         * Text Overflow
         * @see https://tailwindcss.com/docs/text-overflow
         */
        "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
        /**
         * Text Wrap
         * @see https://tailwindcss.com/docs/text-wrap
         */
        "text-wrap": [{
          text: ["wrap", "nowrap", "balance", "pretty"]
        }],
        /**
         * Text Indent
         * @see https://tailwindcss.com/docs/text-indent
         */
        indent: [{
          indent: g()
        }],
        /**
         * Vertical Alignment
         * @see https://tailwindcss.com/docs/vertical-align
         */
        "vertical-align": [{
          align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", W]
        }],
        /**
         * Whitespace
         * @see https://tailwindcss.com/docs/whitespace
         */
        whitespace: [{
          whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
        }],
        /**
         * Word Break
         * @see https://tailwindcss.com/docs/word-break
         */
        break: [{
          break: ["normal", "words", "all", "keep"]
        }],
        /**
         * Hyphens
         * @see https://tailwindcss.com/docs/hyphens
         */
        hyphens: [{
          hyphens: ["none", "manual", "auto"]
        }],
        /**
         * Content
         * @see https://tailwindcss.com/docs/content
         */
        content: [{
          content: ["none", W]
        }],
        // Backgrounds
        /**
         * Background Attachment
         * @see https://tailwindcss.com/docs/background-attachment
         */
        "bg-attachment": [{
          bg: ["fixed", "local", "scroll"]
        }],
        /**
         * Background Clip
         * @see https://tailwindcss.com/docs/background-clip
         */
        "bg-clip": [{
          "bg-clip": ["border", "padding", "content", "text"]
        }],
        /**
         * Background Opacity
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/background-opacity
         */
        "bg-opacity": [{
          "bg-opacity": [P]
        }],
        /**
         * Background Origin
         * @see https://tailwindcss.com/docs/background-origin
         */
        "bg-origin": [{
          "bg-origin": ["border", "padding", "content"]
        }],
        /**
         * Background Position
         * @see https://tailwindcss.com/docs/background-position
         */
        "bg-position": [{
          bg: [...v(), _o]
        }],
        /**
         * Background Repeat
         * @see https://tailwindcss.com/docs/background-repeat
         */
        "bg-repeat": [{
          bg: ["no-repeat", {
            repeat: ["", "x", "y", "round", "space"]
          }]
        }],
        /**
         * Background Size
         * @see https://tailwindcss.com/docs/background-size
         */
        "bg-size": [{
          bg: ["auto", "cover", "contain", wo]
        }],
        /**
         * Background Image
         * @see https://tailwindcss.com/docs/background-image
         */
        "bg-image": [{
          bg: ["none", {
            "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, ko]
        }],
        /**
         * Background Color
         * @see https://tailwindcss.com/docs/background-color
         */
        "bg-color": [{
          bg: [e]
        }],
        /**
         * Gradient Color Stops From Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from-pos": [{
          from: [m]
        }],
        /**
         * Gradient Color Stops Via Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via-pos": [{
          via: [m]
        }],
        /**
         * Gradient Color Stops To Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to-pos": [{
          to: [m]
        }],
        /**
         * Gradient Color Stops From
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from": [{
          from: [h]
        }],
        /**
         * Gradient Color Stops Via
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via": [{
          via: [h]
        }],
        /**
         * Gradient Color Stops To
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to": [{
          to: [h]
        }],
        // Borders
        /**
         * Border Radius
         * @see https://tailwindcss.com/docs/border-radius
         */
        rounded: [{
          rounded: [i]
        }],
        /**
         * Border Radius Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-s": [{
          "rounded-s": [i]
        }],
        /**
         * Border Radius End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-e": [{
          "rounded-e": [i]
        }],
        /**
         * Border Radius Top
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-t": [{
          "rounded-t": [i]
        }],
        /**
         * Border Radius Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-r": [{
          "rounded-r": [i]
        }],
        /**
         * Border Radius Bottom
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-b": [{
          "rounded-b": [i]
        }],
        /**
         * Border Radius Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-l": [{
          "rounded-l": [i]
        }],
        /**
         * Border Radius Start Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ss": [{
          "rounded-ss": [i]
        }],
        /**
         * Border Radius Start End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-se": [{
          "rounded-se": [i]
        }],
        /**
         * Border Radius End End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ee": [{
          "rounded-ee": [i]
        }],
        /**
         * Border Radius End Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-es": [{
          "rounded-es": [i]
        }],
        /**
         * Border Radius Top Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tl": [{
          "rounded-tl": [i]
        }],
        /**
         * Border Radius Top Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tr": [{
          "rounded-tr": [i]
        }],
        /**
         * Border Radius Bottom Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-br": [{
          "rounded-br": [i]
        }],
        /**
         * Border Radius Bottom Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-bl": [{
          "rounded-bl": [i]
        }],
        /**
         * Border Width
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w": [{
          border: [c]
        }],
        /**
         * Border Width X
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-x": [{
          "border-x": [c]
        }],
        /**
         * Border Width Y
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-y": [{
          "border-y": [c]
        }],
        /**
         * Border Width Start
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-s": [{
          "border-s": [c]
        }],
        /**
         * Border Width End
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-e": [{
          "border-e": [c]
        }],
        /**
         * Border Width Top
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-t": [{
          "border-t": [c]
        }],
        /**
         * Border Width Right
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-r": [{
          "border-r": [c]
        }],
        /**
         * Border Width Bottom
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-b": [{
          "border-b": [c]
        }],
        /**
         * Border Width Left
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-l": [{
          "border-l": [c]
        }],
        /**
         * Border Opacity
         * @see https://tailwindcss.com/docs/border-opacity
         */
        "border-opacity": [{
          "border-opacity": [P]
        }],
        /**
         * Border Style
         * @see https://tailwindcss.com/docs/border-style
         */
        "border-style": [{
          border: [...O(), "hidden"]
        }],
        /**
         * Divide Width X
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-x": [{
          "divide-x": [c]
        }],
        /**
         * Divide Width X Reverse
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-x-reverse": ["divide-x-reverse"],
        /**
         * Divide Width Y
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-y": [{
          "divide-y": [c]
        }],
        /**
         * Divide Width Y Reverse
         * @see https://tailwindcss.com/docs/divide-width
         */
        "divide-y-reverse": ["divide-y-reverse"],
        /**
         * Divide Opacity
         * @see https://tailwindcss.com/docs/divide-opacity
         */
        "divide-opacity": [{
          "divide-opacity": [P]
        }],
        /**
         * Divide Style
         * @see https://tailwindcss.com/docs/divide-style
         */
        "divide-style": [{
          divide: O()
        }],
        /**
         * Border Color
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color": [{
          border: [s]
        }],
        /**
         * Border Color X
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-x": [{
          "border-x": [s]
        }],
        /**
         * Border Color Y
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-y": [{
          "border-y": [s]
        }],
        /**
         * Border Color Top
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-t": [{
          "border-t": [s]
        }],
        /**
         * Border Color Right
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-r": [{
          "border-r": [s]
        }],
        /**
         * Border Color Bottom
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-b": [{
          "border-b": [s]
        }],
        /**
         * Border Color Left
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-l": [{
          "border-l": [s]
        }],
        /**
         * Divide Color
         * @see https://tailwindcss.com/docs/divide-color
         */
        "divide-color": [{
          divide: [s]
        }],
        /**
         * Outline Style
         * @see https://tailwindcss.com/docs/outline-style
         */
        "outline-style": [{
          outline: ["", ...O()]
        }],
        /**
         * Outline Offset
         * @see https://tailwindcss.com/docs/outline-offset
         */
        "outline-offset": [{
          "outline-offset": [ge, W]
        }],
        /**
         * Outline Width
         * @see https://tailwindcss.com/docs/outline-width
         */
        "outline-w": [{
          outline: [ge, ye]
        }],
        /**
         * Outline Color
         * @see https://tailwindcss.com/docs/outline-color
         */
        "outline-color": [{
          outline: [e]
        }],
        /**
         * Ring Width
         * @see https://tailwindcss.com/docs/ring-width
         */
        "ring-w": [{
          ring: _()
        }],
        /**
         * Ring Width Inset
         * @see https://tailwindcss.com/docs/ring-width
         */
        "ring-w-inset": ["ring-inset"],
        /**
         * Ring Color
         * @see https://tailwindcss.com/docs/ring-color
         */
        "ring-color": [{
          ring: [e]
        }],
        /**
         * Ring Opacity
         * @see https://tailwindcss.com/docs/ring-opacity
         */
        "ring-opacity": [{
          "ring-opacity": [P]
        }],
        /**
         * Ring Offset Width
         * @see https://tailwindcss.com/docs/ring-offset-width
         */
        "ring-offset-w": [{
          "ring-offset": [ge, ye]
        }],
        /**
         * Ring Offset Color
         * @see https://tailwindcss.com/docs/ring-offset-color
         */
        "ring-offset-color": [{
          "ring-offset": [e]
        }],
        // Effects
        /**
         * Box Shadow
         * @see https://tailwindcss.com/docs/box-shadow
         */
        shadow: [{
          shadow: ["", "inner", "none", xe, Eo]
        }],
        /**
         * Box Shadow Color
         * @see https://tailwindcss.com/docs/box-shadow-color
         */
        "shadow-color": [{
          shadow: [Ue]
        }],
        /**
         * Opacity
         * @see https://tailwindcss.com/docs/opacity
         */
        opacity: [{
          opacity: [P]
        }],
        /**
         * Mix Blend Mode
         * @see https://tailwindcss.com/docs/mix-blend-mode
         */
        "mix-blend": [{
          "mix-blend": [...y(), "plus-lighter", "plus-darker"]
        }],
        /**
         * Background Blend Mode
         * @see https://tailwindcss.com/docs/background-blend-mode
         */
        "bg-blend": [{
          "bg-blend": y()
        }],
        // Filters
        /**
         * Filter
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/filter
         */
        filter: [{
          filter: ["", "none"]
        }],
        /**
         * Blur
         * @see https://tailwindcss.com/docs/blur
         */
        blur: [{
          blur: [r]
        }],
        /**
         * Brightness
         * @see https://tailwindcss.com/docs/brightness
         */
        brightness: [{
          brightness: [o]
        }],
        /**
         * Contrast
         * @see https://tailwindcss.com/docs/contrast
         */
        contrast: [{
          contrast: [u]
        }],
        /**
         * Drop Shadow
         * @see https://tailwindcss.com/docs/drop-shadow
         */
        "drop-shadow": [{
          "drop-shadow": ["", "none", xe, W]
        }],
        /**
         * Grayscale
         * @see https://tailwindcss.com/docs/grayscale
         */
        grayscale: [{
          grayscale: [a]
        }],
        /**
         * Hue Rotate
         * @see https://tailwindcss.com/docs/hue-rotate
         */
        "hue-rotate": [{
          "hue-rotate": [f]
        }],
        /**
         * Invert
         * @see https://tailwindcss.com/docs/invert
         */
        invert: [{
          invert: [d]
        }],
        /**
         * Saturate
         * @see https://tailwindcss.com/docs/saturate
         */
        saturate: [{
          saturate: [$]
        }],
        /**
         * Sepia
         * @see https://tailwindcss.com/docs/sepia
         */
        sepia: [{
          sepia: [M]
        }],
        /**
         * Backdrop Filter
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://tailwindcss.com/docs/backdrop-filter
         */
        "backdrop-filter": [{
          "backdrop-filter": ["", "none"]
        }],
        /**
         * Backdrop Blur
         * @see https://tailwindcss.com/docs/backdrop-blur
         */
        "backdrop-blur": [{
          "backdrop-blur": [r]
        }],
        /**
         * Backdrop Brightness
         * @see https://tailwindcss.com/docs/backdrop-brightness
         */
        "backdrop-brightness": [{
          "backdrop-brightness": [o]
        }],
        /**
         * Backdrop Contrast
         * @see https://tailwindcss.com/docs/backdrop-contrast
         */
        "backdrop-contrast": [{
          "backdrop-contrast": [u]
        }],
        /**
         * Backdrop Grayscale
         * @see https://tailwindcss.com/docs/backdrop-grayscale
         */
        "backdrop-grayscale": [{
          "backdrop-grayscale": [a]
        }],
        /**
         * Backdrop Hue Rotate
         * @see https://tailwindcss.com/docs/backdrop-hue-rotate
         */
        "backdrop-hue-rotate": [{
          "backdrop-hue-rotate": [f]
        }],
        /**
         * Backdrop Invert
         * @see https://tailwindcss.com/docs/backdrop-invert
         */
        "backdrop-invert": [{
          "backdrop-invert": [d]
        }],
        /**
         * Backdrop Opacity
         * @see https://tailwindcss.com/docs/backdrop-opacity
         */
        "backdrop-opacity": [{
          "backdrop-opacity": [P]
        }],
        /**
         * Backdrop Saturate
         * @see https://tailwindcss.com/docs/backdrop-saturate
         */
        "backdrop-saturate": [{
          "backdrop-saturate": [$]
        }],
        /**
         * Backdrop Sepia
         * @see https://tailwindcss.com/docs/backdrop-sepia
         */
        "backdrop-sepia": [{
          "backdrop-sepia": [M]
        }],
        // Tables
        /**
         * Border Collapse
         * @see https://tailwindcss.com/docs/border-collapse
         */
        "border-collapse": [{
          border: ["collapse", "separate"]
        }],
        /**
         * Border Spacing
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing": [{
          "border-spacing": [n]
        }],
        /**
         * Border Spacing X
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-x": [{
          "border-spacing-x": [n]
        }],
        /**
         * Border Spacing Y
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-y": [{
          "border-spacing-y": [n]
        }],
        /**
         * Table Layout
         * @see https://tailwindcss.com/docs/table-layout
         */
        "table-layout": [{
          table: ["auto", "fixed"]
        }],
        /**
         * Caption Side
         * @see https://tailwindcss.com/docs/caption-side
         */
        caption: [{
          caption: ["top", "bottom"]
        }],
        // Transitions and Animation
        /**
         * Tranisition Property
         * @see https://tailwindcss.com/docs/transition-property
         */
        transition: [{
          transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", W]
        }],
        /**
         * Transition Duration
         * @see https://tailwindcss.com/docs/transition-duration
         */
        duration: [{
          duration: U()
        }],
        /**
         * Transition Timing Function
         * @see https://tailwindcss.com/docs/transition-timing-function
         */
        ease: [{
          ease: ["linear", "in", "out", "in-out", W]
        }],
        /**
         * Transition Delay
         * @see https://tailwindcss.com/docs/transition-delay
         */
        delay: [{
          delay: U()
        }],
        /**
         * Animation
         * @see https://tailwindcss.com/docs/animation
         */
        animate: [{
          animate: ["none", "spin", "ping", "pulse", "bounce", W]
        }],
        // Transforms
        /**
         * Transform
         * @see https://tailwindcss.com/docs/transform
         */
        transform: [{
          transform: ["", "gpu", "none"]
        }],
        /**
         * Scale
         * @see https://tailwindcss.com/docs/scale
         */
        scale: [{
          scale: [z]
        }],
        /**
         * Scale X
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-x": [{
          "scale-x": [z]
        }],
        /**
         * Scale Y
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-y": [{
          "scale-y": [z]
        }],
        /**
         * Rotate
         * @see https://tailwindcss.com/docs/rotate
         */
        rotate: [{
          rotate: [Ve, W]
        }],
        /**
         * Translate X
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-x": [{
          "translate-x": [J]
        }],
        /**
         * Translate Y
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-y": [{
          "translate-y": [J]
        }],
        /**
         * Skew X
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-x": [{
          "skew-x": [G]
        }],
        /**
         * Skew Y
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-y": [{
          "skew-y": [G]
        }],
        /**
         * Transform Origin
         * @see https://tailwindcss.com/docs/transform-origin
         */
        "transform-origin": [{
          origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", W]
        }],
        // Interactivity
        /**
         * Accent Color
         * @see https://tailwindcss.com/docs/accent-color
         */
        accent: [{
          accent: ["auto", e]
        }],
        /**
         * Appearance
         * @see https://tailwindcss.com/docs/appearance
         */
        appearance: [{
          appearance: ["none", "auto"]
        }],
        /**
         * Cursor
         * @see https://tailwindcss.com/docs/cursor
         */
        cursor: [{
          cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", W]
        }],
        /**
         * Caret Color
         * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
         */
        "caret-color": [{
          caret: [e]
        }],
        /**
         * Pointer Events
         * @see https://tailwindcss.com/docs/pointer-events
         */
        "pointer-events": [{
          "pointer-events": ["none", "auto"]
        }],
        /**
         * Resize
         * @see https://tailwindcss.com/docs/resize
         */
        resize: [{
          resize: ["none", "y", "x", ""]
        }],
        /**
         * Scroll Behavior
         * @see https://tailwindcss.com/docs/scroll-behavior
         */
        "scroll-behavior": [{
          scroll: ["auto", "smooth"]
        }],
        /**
         * Scroll Margin
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-m": [{
          "scroll-m": g()
        }],
        /**
         * Scroll Margin X
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mx": [{
          "scroll-mx": g()
        }],
        /**
         * Scroll Margin Y
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-my": [{
          "scroll-my": g()
        }],
        /**
         * Scroll Margin Start
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ms": [{
          "scroll-ms": g()
        }],
        /**
         * Scroll Margin End
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-me": [{
          "scroll-me": g()
        }],
        /**
         * Scroll Margin Top
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mt": [{
          "scroll-mt": g()
        }],
        /**
         * Scroll Margin Right
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mr": [{
          "scroll-mr": g()
        }],
        /**
         * Scroll Margin Bottom
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mb": [{
          "scroll-mb": g()
        }],
        /**
         * Scroll Margin Left
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ml": [{
          "scroll-ml": g()
        }],
        /**
         * Scroll Padding
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-p": [{
          "scroll-p": g()
        }],
        /**
         * Scroll Padding X
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-px": [{
          "scroll-px": g()
        }],
        /**
         * Scroll Padding Y
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-py": [{
          "scroll-py": g()
        }],
        /**
         * Scroll Padding Start
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-ps": [{
          "scroll-ps": g()
        }],
        /**
         * Scroll Padding End
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pe": [{
          "scroll-pe": g()
        }],
        /**
         * Scroll Padding Top
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pt": [{
          "scroll-pt": g()
        }],
        /**
         * Scroll Padding Right
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pr": [{
          "scroll-pr": g()
        }],
        /**
         * Scroll Padding Bottom
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pb": [{
          "scroll-pb": g()
        }],
        /**
         * Scroll Padding Left
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pl": [{
          "scroll-pl": g()
        }],
        /**
         * Scroll Snap Align
         * @see https://tailwindcss.com/docs/scroll-snap-align
         */
        "snap-align": [{
          snap: ["start", "end", "center", "align-none"]
        }],
        /**
         * Scroll Snap Stop
         * @see https://tailwindcss.com/docs/scroll-snap-stop
         */
        "snap-stop": [{
          snap: ["normal", "always"]
        }],
        /**
         * Scroll Snap Type
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-type": [{
          snap: ["none", "x", "y", "both"]
        }],
        /**
         * Scroll Snap Type Strictness
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-strictness": [{
          snap: ["mandatory", "proximity"]
        }],
        /**
         * Touch Action
         * @see https://tailwindcss.com/docs/touch-action
         */
        touch: [{
          touch: ["auto", "none", "manipulation"]
        }],
        /**
         * Touch Action X
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-x": [{
          "touch-pan": ["x", "left", "right"]
        }],
        /**
         * Touch Action Y
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-y": [{
          "touch-pan": ["y", "up", "down"]
        }],
        /**
         * Touch Action Pinch Zoom
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-pz": ["touch-pinch-zoom"],
        /**
         * User Select
         * @see https://tailwindcss.com/docs/user-select
         */
        select: [{
          select: ["none", "text", "all", "auto"]
        }],
        /**
         * Will Change
         * @see https://tailwindcss.com/docs/will-change
         */
        "will-change": [{
          "will-change": ["auto", "scroll", "contents", "transform", W]
        }],
        // SVG
        /**
         * Fill
         * @see https://tailwindcss.com/docs/fill
         */
        fill: [{
          fill: [e, "none"]
        }],
        /**
         * Stroke Width
         * @see https://tailwindcss.com/docs/stroke-width
         */
        "stroke-w": [{
          stroke: [ge, ye, vt]
        }],
        /**
         * Stroke
         * @see https://tailwindcss.com/docs/stroke
         */
        stroke: [{
          stroke: [e, "none"]
        }],
        // Accessibility
        /**
         * Screen Readers
         * @see https://tailwindcss.com/docs/screen-readers
         */
        sr: ["sr-only", "not-sr-only"],
        /**
         * Forced Color Adjust
         * @see https://tailwindcss.com/docs/forced-color-adjust
         */
        "forced-color-adjust": [{
          "forced-color-adjust": ["auto", "none"]
        }]
      },
      conflictingClassGroups: {
        overflow: ["overflow-x", "overflow-y"],
        overscroll: ["overscroll-x", "overscroll-y"],
        inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
        "inset-x": ["right", "left"],
        "inset-y": ["top", "bottom"],
        flex: ["basis", "grow", "shrink"],
        gap: ["gap-x", "gap-y"],
        p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
        px: ["pr", "pl"],
        py: ["pt", "pb"],
        m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
        mx: ["mr", "ml"],
        my: ["mt", "mb"],
        size: ["w", "h"],
        "font-size": ["leading"],
        "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
        "fvn-ordinal": ["fvn-normal"],
        "fvn-slashed-zero": ["fvn-normal"],
        "fvn-figure": ["fvn-normal"],
        "fvn-spacing": ["fvn-normal"],
        "fvn-fraction": ["fvn-normal"],
        "line-clamp": ["display", "overflow"],
        rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
        "rounded-s": ["rounded-ss", "rounded-es"],
        "rounded-e": ["rounded-se", "rounded-ee"],
        "rounded-t": ["rounded-tl", "rounded-tr"],
        "rounded-r": ["rounded-tr", "rounded-br"],
        "rounded-b": ["rounded-br", "rounded-bl"],
        "rounded-l": ["rounded-tl", "rounded-bl"],
        "border-spacing": ["border-spacing-x", "border-spacing-y"],
        "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
        "border-w-x": ["border-w-r", "border-w-l"],
        "border-w-y": ["border-w-t", "border-w-b"],
        "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
        "border-color-x": ["border-color-r", "border-color-l"],
        "border-color-y": ["border-color-t", "border-color-b"],
        "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
        "scroll-mx": ["scroll-mr", "scroll-ml"],
        "scroll-my": ["scroll-mt", "scroll-mb"],
        "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
        "scroll-px": ["scroll-pr", "scroll-pl"],
        "scroll-py": ["scroll-pt", "scroll-pb"],
        touch: ["touch-x", "touch-y", "touch-pz"],
        "touch-x": ["touch"],
        "touch-y": ["touch"],
        "touch-pz": ["touch"]
      },
      conflictingClassGroupModifiers: {
        "font-size": ["leading"]
      }
    };
  },
  To = (e, _ref64) => {
    let {
      cacheSize: t,
      prefix: r,
      separator: o,
      experimentalParseClassName: s,
      extend: i = {},
      override: n = {}
    } = _ref64;
    He(e, "cacheSize", t), He(e, "prefix", r), He(e, "separator", o), He(e, "experimentalParseClassName", s);
    for (const c in n) Ro(e[c], n[c]);
    for (const c in i) Po(e[c], i[c]);
    return e;
  },
  He = (e, t, r) => {
    r !== void 0 && (e[t] = r);
  },
  Ro = (e, t) => {
    if (t) for (const r in t) He(e, r, t[r]);
  },
  Po = (e, t) => {
    if (t) for (const r in t) {
      const o = t[r];
      o !== void 0 && (e[r] = (e[r] || []).concat(o));
    }
  },
  jo = function (e) {
    for (var _len6 = arguments.length, t = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      t[_key6 - 1] = arguments[_key6];
    }
    return typeof e == "function" ? ir(ar, e, ...t) : ir(() => To(ar(), e), ...t);
  },
  Ze = Object.keys(Nr),
  wt = Object.keys($r),
  Fo = jo({
    extend: {
      classGroups: {
        "font-size": [{
          text: Ze
        }],
        "font-weight": [{
          text: Ze
        }],
        leading: [{
          text: Ze
        }],
        tracking: [{
          text: Ze
        }],
        "bg-color": [{
          bg: wt
        }],
        "text-color": [{
          text: wt
        }],
        "border-color": [{
          border: wt
        }]
      }
    }
  }),
  ve = function () {
    for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      e[_key7] = arguments[_key7];
    }
    return Fo(ce(e));
  },
  Ii = se.memo(_ref65 => {
    let {
      children: e,
      onClose: t,
      isShow: r,
      className: o,
      isDrawerModal: s,
      isCenterScreen: i = !1
    } = _ref65;
    const n = Jn("sm"),
      c = () => {
        t();
      },
      u = a => {
        a.stopPropagation();
      };
    return r ? /* @__PURE__ */L.jsx("div", {
      className: ve(
      // 'fixed w-full h-full top-0 left-0 flex justify-center items-center z-50 bg-[#00000099]',
      // 'fixed inset-0 flex justify-center items-start sm:items-center bg-[#00000099] z-50 pt-[3vh] sm:pt-0',
      "fixed inset-0 flex justify-center  bg-[#00000099] z-50", i ? "items-center" : "items-start pt-[3vh]", s && n && "items-end"),
      onClick: c,
      children: /* @__PURE__ */L.jsx("div", {
        className: ve("relative w-full h-auto flex flex-col sm:max-w-[540px] max-h-[97vh] p-[20px] sm:p-[24px] z-[100] border-[.5px] border-black-4 rounded-[12px] bg-black-2 overflow-y-auto", !s && n && "max-w-[90vw]", o),
        onClick: u,
        children: e
      })
    }) : null;
  }),
  Do = "_wrap_1o4wa_1",
  zo = "_active_1o4wa_4",
  _t = {
    wrap: Do,
    active: zo
  },
  Vi = pr((e, t) => {
    const {
        images: r,
        leftIcon: o,
        value: s,
        placeholder: i,
        onChange: n,
        className: c,
        label: u,
        type: a = "text",
        rightButton: f,
        size: d,
        ...p
      } = e,
      [h, m] = ot(!1);
    return /* @__PURE__ */L.jsxs("div", {
      className: ce("flex items- w-full flex-col", c),
      children: [!!u && /* @__PURE__ */L.jsx("label", {
        className: "text-r14 text-white",
        children: u
      }), /* @__PURE__ */L.jsxs("div", {
        className: ce("bg-black-3 relative flex items-center w-full rounded-[6px] px-16 gap-8 transition", u ? "mt-8" : "", _t.wrap, h ? _t.active : "", f || d === "xl" ? "h-56" : "h-48"),
        children: [!!o && /* @__PURE__ */L.jsx("img", {
          src: o,
          width: 20,
          height: 20,
          className: "absolute left-16"
        }), !!r && /* @__PURE__ */L.jsx("div", {
          className: "flex items-center",
          children: r
        }), /* @__PURE__ */L.jsx("input", {
          ref: t,
          className: ce(_t.input, "h-full w-full text-r14 bg-[transparent] text-white", o ? "pl-44" : ""),
          type: a,
          autoComplete: "off",
          value: s,
          placeholder: i,
          onChange: n,
          onFocus: () => {
            m(!0);
          },
          onBlur: () => {
            m(!1);
          },
          ...p
        }), !!f && f]
      })]
    });
  }),
  Lo = "_image_697b3_1",
  Mo = {
    image: Lo
  },
  $o = se.memo(pr((e, t) => {
    const {
        className: r,
        src: o,
        color: s,
        size: i,
        style: n,
        fullWidth: c,
        ...u
      } = e,
      a = Dn(() => {
        const f = typeof i == "number",
          d = c ? "100%" : f ? `${i}px` : `${i.w}px`,
          p = f ? `${i}px` : `${i.h}px`,
          h = {
            width: d,
            height: p,
            minWidth: d
          },
          m = `url(${o})`;
        return s ? {
          ...h,
          maskImage: m,
          WebkitMaskImage: m,
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskPosition: "center center",
          WebkitMaskSize: "contain"
        } : {
          ...h,
          backgroundImage: m,
          ...n
        };
      }, [o, i, s, n, c]);
    return o ? /* @__PURE__ */L.jsx("span", {
      ref: t,
      ...u,
      className: ce(r, Mo.image, "inline-block", {
        [`bg-${s}`]: !!s
      }),
      style: a
    }) : (console.error("You must pass the image src"), null);
  }));
$o.displayName = "Image";
const No = se.memo(se.forwardRef((e, t) => {
  const {
    className: r,
    tag: o = "div",
    font: s = "inter",
    message: i,
    size: n = "r14",
    sizeSm: c = "",
    color: u = "white",
    html: a,
    onClick: f,
    ...d
  } = e;
  if (f && o !== "button") throw new Error(`You can't use "onClick" without passing tag === "button". Create components ADA friendly!`);
  const p = ce(c ? [`text-${c} sm:text-${n}`] : [`text-${n}`], [`text-font-${s}`], [`text-${u}`], r),
    h = {
      ...d,
      ref: t,
      onClick: f,
      className: p
    };
  return a ? se.createElement(o, {
    ...h,
    dangerouslySetInnerHTML: {
      __html: i
    }
  }) : se.createElement(o, h, i);
}));
No.displayName = "Text";
const sr = Math.min,
  Ge = Math.max,
  rt = Math.round,
  we = e => ({
    x: e,
    y: e
  });
function Wo(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Mt(e) {
  return e.split("-")[0];
}
function qr(e) {
  return e.split("-")[1];
}
function Bo(e) {
  return e === "x" ? "y" : "x";
}
function Io(e) {
  return e === "y" ? "height" : "width";
}
const Vo = /* @__PURE__ */new Set(["top", "bottom"]);
function $t(e) {
  return Vo.has(Mt(e)) ? "y" : "x";
}
function Uo(e) {
  return Bo($t(e));
}
function Yr(e) {
  const {
    x: t,
    y: r,
    width: o,
    height: s
  } = e;
  return {
    width: o,
    height: s,
    top: r,
    left: t,
    right: t + o,
    bottom: r + s,
    x: t,
    y: r
  };
}
function lr(e, t, r) {
  let {
    reference: o,
    floating: s
  } = e;
  const i = $t(t),
    n = Uo(t),
    c = Io(n),
    u = Mt(t),
    a = i === "y",
    f = o.x + o.width / 2 - s.width / 2,
    d = o.y + o.height / 2 - s.height / 2,
    p = o[c] / 2 - s[c] / 2;
  let h;
  switch (u) {
    case "top":
      h = {
        x: f,
        y: o.y - s.height
      };
      break;
    case "bottom":
      h = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: o.x - s.width,
        y: d
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (qr(t)) {
    case "start":
      h[n] -= p * (r && a ? -1 : 1);
      break;
    case "end":
      h[n] += p * (r && a ? -1 : 1);
      break;
  }
  return h;
}
const Ho = async (e, t, r) => {
  const {
      placement: o = "bottom",
      strategy: s = "absolute",
      middleware: i = [],
      platform: n
    } = r,
    c = i.filter(Boolean),
    u = await (n.isRTL == null ? void 0 : n.isRTL(t));
  let a = await n.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }),
    {
      x: f,
      y: d
    } = lr(a, o, u),
    p = o,
    h = {},
    m = 0;
  for (let x = 0; x < c.length; x++) {
    const {
        name: k,
        fn: P
      } = c[x],
      {
        x: R,
        y: $,
        data: z,
        reset: M
      } = await P({
        x: f,
        y: d,
        initialPlacement: o,
        placement: p,
        strategy: s,
        middlewareData: h,
        rects: a,
        platform: n,
        elements: {
          reference: e,
          floating: t
        }
      });
    f = R !== null && R !== void 0 ? R : f, d = $ !== null && $ !== void 0 ? $ : d, h = {
      ...h,
      [k]: {
        ...h[k],
        ...z
      }
    }, M && m <= 50 && (m++, typeof M == "object" && (M.placement && (p = M.placement), M.rects && (a = M.rects === !0 ? await n.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : M.rects), {
      x: f,
      y: d
    } = lr(a, p, u)), x = -1);
  }
  return {
    x: f,
    y: d,
    placement: p,
    strategy: s,
    middlewareData: h
  };
};
async function Go(e, t) {
  const {
      placement: r,
      platform: o,
      elements: s
    } = e,
    i = await (o.isRTL == null ? void 0 : o.isRTL(s.floating)),
    n = Mt(r),
    c = qr(r),
    u = $t(r) === "y",
    a = ["left", "top"].includes(n) ? -1 : 1,
    f = i && u ? -1 : 1,
    d = Wo(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return c && typeof m == "number" && (h = c === "end" ? m * -1 : m), u ? {
    x: h * f,
    y: p * a
  } : {
    x: p * a,
    y: h * f
  };
}
const qo = function (e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, o;
      const {
          x: s,
          y: i,
          placement: n,
          middlewareData: c
        } = t,
        u = await Go(t, e);
      return n === ((r = c.offset) == null ? void 0 : r.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
        x: s + u.x,
        y: i + u.y,
        data: {
          ...u,
          placement: n
        }
      };
    }
  };
};
function ct() {
  return typeof window < "u";
}
function _e(e) {
  return Kr(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function oe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ce(e) {
  var t;
  return (t = (Kr(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Kr(e) {
  return ct() ? e instanceof Node || e instanceof oe(e).Node : !1;
}
function de(e) {
  return ct() ? e instanceof Element || e instanceof oe(e).Element : !1;
}
function pe(e) {
  return ct() ? e instanceof HTMLElement || e instanceof oe(e).HTMLElement : !1;
}
function cr(e) {
  return !ct() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof oe(e).ShadowRoot;
}
const Yo = /* @__PURE__ */new Set(["inline", "contents"]);
function Ke(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: o,
    display: s
  } = le(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + r) && !Yo.has(s);
}
const Ko = /* @__PURE__ */new Set(["table", "td", "th"]);
function Xo(e) {
  return Ko.has(_e(e));
}
const Jo = [":popover-open", ":modal"];
function Zo(e) {
  return Jo.some(t => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Qo = ["transform", "translate", "scale", "rotate", "perspective"],
  ei = ["transform", "translate", "scale", "rotate", "perspective", "filter"],
  ti = ["paint", "layout", "strict", "content"];
function Nt(e) {
  const t = Wt(),
    r = de(e) ? le(e) : e;
  return Qo.some(o => r[o] ? r[o] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ei.some(o => (r.willChange || "").includes(o)) || ti.some(o => (r.contain || "").includes(o));
}
function ri(e) {
  let t = ze(e);
  for (; pe(t) && !ut(t);) {
    if (Nt(t)) return t;
    if (Zo(t)) return null;
    t = ze(t);
  }
  return null;
}
function Wt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const ni = /* @__PURE__ */new Set(["html", "body", "#document"]);
function ut(e) {
  return ni.has(_e(e));
}
function le(e) {
  return oe(e).getComputedStyle(e);
}
function ft(e) {
  return de(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ze(e) {
  if (_e(e) === "html") return e;
  const t =
  // Step into the shadow DOM of the parent of a slotted node.
  e.assignedSlot ||
  // DOM Element detected.
  e.parentNode ||
  // ShadowRoot detected.
  cr(e) && e.host ||
  // Fallback.
  Ce(e);
  return cr(t) ? t.host : t;
}
function Xr(e) {
  const t = ze(e);
  return ut(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : pe(t) && Ke(t) ? t : Xr(t);
}
function Tt(e, t, r) {
  var o;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const s = Xr(e),
    i = s === ((o = e.ownerDocument) == null ? void 0 : o.body),
    n = oe(s);
  if (i) {
    const c = oi(n);
    return t.concat(n, n.visualViewport || [], Ke(s) ? s : [], c && r ? Tt(c) : []);
  }
  return t.concat(s, Tt(s, [], r));
}
function oi(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Jr(e) {
  const t = le(e);
  let r = parseFloat(t.width) || 0,
    o = parseFloat(t.height) || 0;
  const s = pe(e),
    i = s ? e.offsetWidth : r,
    n = s ? e.offsetHeight : o,
    c = rt(r) !== i || rt(o) !== n;
  return c && (r = i, o = n), {
    width: r,
    height: o,
    $: c
  };
}
function Zr(e) {
  return de(e) ? e : e.contextElement;
}
function De(e) {
  const t = Zr(e);
  if (!pe(t)) return we(1);
  const r = t.getBoundingClientRect(),
    {
      width: o,
      height: s,
      $: i
    } = Jr(t);
  let n = (i ? rt(r.width) : r.width) / o,
    c = (i ? rt(r.height) : r.height) / s;
  return (!n || !Number.isFinite(n)) && (n = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: n,
    y: c
  };
}
const ii = /* @__PURE__ */we(0);
function Qr(e) {
  const t = oe(e);
  return !Wt() || !t.visualViewport ? ii : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ai(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== oe(e) ? !1 : t;
}
function Ye(e, t, r, o) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const s = e.getBoundingClientRect(),
    i = Zr(e);
  let n = we(1);
  t && (o ? de(o) && (n = De(o)) : n = De(e));
  const c = ai(i, r, o) ? Qr(i) : we(0);
  let u = (s.left + c.x) / n.x,
    a = (s.top + c.y) / n.y,
    f = s.width / n.x,
    d = s.height / n.y;
  if (i) {
    const p = oe(i),
      h = o && de(o) ? oe(o) : o;
    let m = p,
      x = m.frameElement;
    for (; x && o && h !== m;) {
      const k = De(x),
        P = x.getBoundingClientRect(),
        R = le(x),
        $ = P.left + (x.clientLeft + parseFloat(R.paddingLeft)) * k.x,
        z = P.top + (x.clientTop + parseFloat(R.paddingTop)) * k.y;
      u *= k.x, a *= k.y, f *= k.x, d *= k.y, u += $, a += z, m = oe(x), x = m.frameElement;
    }
  }
  return Yr({
    width: f,
    height: d,
    x: u,
    y: a
  });
}
const si = [":popover-open", ":modal"];
function en(e) {
  return si.some(t => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function li(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: o,
    strategy: s
  } = e;
  const i = s === "fixed",
    n = Ce(o),
    c = t ? en(t.floating) : !1;
  if (o === n || c && i) return r;
  let u = {
      scrollLeft: 0,
      scrollTop: 0
    },
    a = we(1);
  const f = we(0),
    d = pe(o);
  if ((d || !d && !i) && ((_e(o) !== "body" || Ke(n)) && (u = ft(o)), pe(o))) {
    const p = Ye(o);
    a = De(o), f.x = p.x + o.clientLeft, f.y = p.y + o.clientTop;
  }
  return {
    width: r.width * a.x,
    height: r.height * a.y,
    x: r.x * a.x - u.scrollLeft * a.x + f.x,
    y: r.y * a.y - u.scrollTop * a.y + f.y
  };
}
function ci(e) {
  return Array.from(e.getClientRects());
}
function tn(e) {
  return Ye(Ce(e)).left + ft(e).scrollLeft;
}
function ui(e) {
  const t = Ce(e),
    r = ft(e),
    o = e.ownerDocument.body,
    s = Ge(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth),
    i = Ge(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let n = -r.scrollLeft + tn(e);
  const c = -r.scrollTop;
  return le(o).direction === "rtl" && (n += Ge(t.clientWidth, o.clientWidth) - s), {
    width: s,
    height: i,
    x: n,
    y: c
  };
}
function fi(e, t) {
  const r = oe(e),
    o = Ce(e),
    s = r.visualViewport;
  let i = o.clientWidth,
    n = o.clientHeight,
    c = 0,
    u = 0;
  if (s) {
    i = s.width, n = s.height;
    const a = Wt();
    (!a || a && t === "fixed") && (c = s.offsetLeft, u = s.offsetTop);
  }
  return {
    width: i,
    height: n,
    x: c,
    y: u
  };
}
function di(e, t) {
  const r = Ye(e, !0, t === "fixed"),
    o = r.top + e.clientTop,
    s = r.left + e.clientLeft,
    i = pe(e) ? De(e) : we(1),
    n = e.clientWidth * i.x,
    c = e.clientHeight * i.y,
    u = s * i.x,
    a = o * i.y;
  return {
    width: n,
    height: c,
    x: u,
    y: a
  };
}
function ur(e, t, r) {
  let o;
  if (t === "viewport") o = fi(e, r);else if (t === "document") o = ui(Ce(e));else if (de(t)) o = di(t, r);else {
    const s = Qr(e);
    o = {
      ...t,
      x: t.x - s.x,
      y: t.y - s.y
    };
  }
  return Yr(o);
}
function rn(e, t) {
  const r = ze(e);
  return r === t || !de(r) || ut(r) ? !1 : le(r).position === "fixed" || rn(r, t);
}
function pi(e, t) {
  const r = t.get(e);
  if (r) return r;
  let o = Tt(e, [], !1).filter(c => de(c) && _e(c) !== "body"),
    s = null;
  const i = le(e).position === "fixed";
  let n = i ? ze(e) : e;
  for (; de(n) && !ut(n);) {
    const c = le(n),
      u = Nt(n);
    !u && c.position === "fixed" && (s = null), (i ? !u && !s : !u && c.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || Ke(n) && !u && rn(e, n)) ? o = o.filter(f => f !== n) : s = c, n = ze(n);
  }
  return t.set(e, o), o;
}
function gi(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: o,
    strategy: s
  } = e;
  const n = [...(r === "clippingAncestors" ? pi(t, this._c) : [].concat(r)), o],
    c = n[0],
    u = n.reduce((a, f) => {
      const d = ur(t, f, s);
      return a.top = Ge(d.top, a.top), a.right = sr(d.right, a.right), a.bottom = sr(d.bottom, a.bottom), a.left = Ge(d.left, a.left), a;
    }, ur(t, c, s));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function mi(e) {
  const {
    width: t,
    height: r
  } = Jr(e);
  return {
    width: t,
    height: r
  };
}
function hi(e, t, r) {
  const o = pe(t),
    s = Ce(t),
    i = r === "fixed",
    n = Ye(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = we(0);
  if (o || !o && !i) if ((_e(t) !== "body" || Ke(s)) && (c = ft(t)), o) {
    const d = Ye(t, !0, i, t);
    u.x = d.x + t.clientLeft, u.y = d.y + t.clientTop;
  } else s && (u.x = tn(s));
  const a = n.left + c.scrollLeft - u.x,
    f = n.top + c.scrollTop - u.y;
  return {
    x: a,
    y: f,
    width: n.width,
    height: n.height
  };
}
function fr(e, t) {
  return !pe(e) || le(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function nn(e, t) {
  const r = oe(e);
  if (!pe(e) || en(e)) return r;
  let o = fr(e, t);
  for (; o && Xo(o) && le(o).position === "static";) o = fr(o, t);
  return o && (_e(o) === "html" || _e(o) === "body" && le(o).position === "static" && !Nt(o)) ? r : o || ri(e) || r;
}
const bi = async function (e) {
  const t = this.getOffsetParent || nn,
    r = this.getDimensions;
  return {
    reference: hi(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await r(e.floating))
    }
  };
};
function yi(e) {
  return le(e).direction === "rtl";
}
const xi = {
    convertOffsetParentRelativeRectToViewportRelativeRect: li,
    getDocumentElement: Ce,
    getClippingRect: gi,
    getOffsetParent: nn,
    getElementRects: bi,
    getClientRects: ci,
    getDimensions: mi,
    getScale: De,
    isElement: de,
    isRTL: yi
  },
  vi = (e, t, r) => {
    const o = /* @__PURE__ */new Map(),
      s = {
        platform: xi,
        ...r
      },
      i = {
        ...s.platform,
        _c: o
      };
    return Ho(e, t, {
      ...s,
      platform: i
    });
  };
var tt = typeof document < "u" ? zn : it;
function nt(e, t) {
  if (e === t) return !0;
  if (typeof e != typeof t) return !1;
  if (typeof e == "function" && e.toString() === t.toString()) return !0;
  let r, o, s;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (o = r; o-- !== 0;) if (!nt(e[o], t[o])) return !1;
      return !0;
    }
    if (s = Object.keys(e), r = s.length, r !== Object.keys(t).length) return !1;
    for (o = r; o-- !== 0;) if (!{}.hasOwnProperty.call(t, s[o])) return !1;
    for (o = r; o-- !== 0;) {
      const i = s[o];
      if (!(i === "_owner" && e.$$typeof) && !nt(e[i], t[i])) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function on(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function dr(e, t) {
  const r = on(e);
  return Math.round(t * r) / r;
}
function Ct(e) {
  const t = Q.useRef(e);
  return tt(() => {
    t.current = e;
  }), t;
}
function wi(e) {
  e === void 0 && (e = {});
  const {
      placement: t = "bottom",
      strategy: r = "absolute",
      middleware: o = [],
      platform: s,
      elements: {
        reference: i,
        floating: n
      } = {},
      transform: c = !0,
      whileElementsMounted: u,
      open: a
    } = e,
    [f, d] = Q.useState({
      x: 0,
      y: 0,
      strategy: r,
      placement: t,
      middlewareData: {},
      isPositioned: !1
    }),
    [p, h] = Q.useState(o);
  nt(p, o) || h(o);
  const [m, x] = Q.useState(null),
    [k, P] = Q.useState(null),
    R = Q.useCallback(C => {
      C !== G.current && (G.current = C, x(C));
    }, []),
    $ = Q.useCallback(C => {
      C !== Y.current && (Y.current = C, P(C));
    }, []),
    z = i || m,
    M = n || k,
    G = Q.useRef(null),
    Y = Q.useRef(null),
    J = Q.useRef(f),
    w = u != null,
    A = Ct(u),
    T = Ct(s),
    g = Ct(a),
    _ = Q.useCallback(() => {
      if (!G.current || !Y.current) return;
      const C = {
        placement: t,
        strategy: r,
        middleware: p
      };
      T.current && (C.platform = T.current), vi(G.current, Y.current, C).then(F => {
        const j = {
          ...F,
          // The floating element's position may be recomputed while it's closed
          // but still mounted (such as when transitioning out). To ensure
          // `isPositioned` will be `false` initially on the next open, avoid
          // setting it to `true` when `open === false` (must be specified).
          isPositioned: g.current !== !1
        };
        E.current && !nt(J.current, j) && (J.current = j, Mn.flushSync(() => {
          d(j);
        }));
      });
    }, [p, t, r, T, g]);
  tt(() => {
    a === !1 && J.current.isPositioned && (J.current.isPositioned = !1, d(C => ({
      ...C,
      isPositioned: !1
    })));
  }, [a]);
  const E = Q.useRef(!1);
  tt(() => (E.current = !0, () => {
    E.current = !1;
  }), []), tt(() => {
    if (z && (G.current = z), M && (Y.current = M), z && M) {
      if (A.current) return A.current(z, M, _);
      _();
    }
  }, [z, M, _, A, w]);
  const v = Q.useMemo(() => ({
      reference: G,
      floating: Y,
      setReference: R,
      setFloating: $
    }), [R, $]),
    O = Q.useMemo(() => ({
      reference: z,
      floating: M
    }), [z, M]),
    y = Q.useMemo(() => {
      const C = {
        position: r,
        left: 0,
        top: 0
      };
      if (!O.floating) return C;
      const F = dr(O.floating, f.x),
        j = dr(O.floating, f.y);
      return c ? {
        ...C,
        transform: "translate(" + F + "px, " + j + "px)",
        ...(on(O.floating) >= 1.5 && {
          willChange: "transform"
        })
      } : {
        position: r,
        left: F,
        top: j
      };
    }, [r, c, O.floating, f.x, f.y]);
  return Q.useMemo(() => ({
    ...f,
    update: _,
    refs: v,
    elements: O,
    floatingStyles: y
  }), [f, _, v, O, y]);
}
const _i = (e, t) => ({
    ...qo(e),
    options: [e, t]
  }),
  Ci = 1500,
  ki = 333,
  an = 4,
  sn = "hover",
  ln = "bottom",
  cn = _ref66 => {
    let {
      mode: e = sn,
      strategy: t,
      position: r = ln,
      offsetPx: o = an,
      disabled: s,
      autoClose: i
    } = _ref66;
    const [n, c] = ot(!1),
      u = Un(n && !s, ki),
      a = e === "hover" ? u : n && !s,
      f = Ln(),
      {
        refs: d,
        floatingStyles: p
      } = wi({
        open: a,
        placement: r,
        middleware: [_i(o)],
        strategy: t
      }),
      m = e === "hover" ? {
        onMouseEnter: () => c(!0),
        onMouseLeave: () => c(!1)
      } : {
        onClick: x => {
          x.stopPropagation(), c(k => !k), document.body.click(), i && setTimeout(() => c(!1), Ci);
        }
      };
    return it(() => {
      if (e === "hover" || !a) return;
      const x = k => {
        d.reference.current && !d.reference.current.contains(k.target) && c(!1);
      };
      return document.addEventListener("click", x), () => {
        document.removeEventListener("click", x);
      };
    }, [e, d.reference, a]), {
      floatingStyles: p,
      refs: d,
      refElementProps: m,
      id: f,
      open: a
    };
  },
  Ei = _ref67 => {
    let {
      content: e,
      children: t,
      mode: r = sn,
      position: o = ln,
      offsetPx: s = an,
      strategy: i,
      className: n,
      refElClassName: c,
      disabled: u,
      autoClose: a
    } = _ref67;
    const {
      open: f,
      id: d,
      refs: p,
      floatingStyles: h,
      refElementProps: m
    } = cn({
      mode: r,
      position: o,
      strategy: i,
      offsetPx: s,
      disabled: u,
      autoClose: a
    });
    return /* @__PURE__ */L.jsxs(L.Fragment, {
      children: [/* @__PURE__ */L.jsx("div", {
        id: `button-${d}`,
        ref: p.setReference,
        "aria-describedby": f ? d : void 0,
        ...m,
        className: ve("w-auto", c),
        children: t
      }), f && !!e && /* @__PURE__ */L.jsx("div", {
        id: d,
        ref: p.setFloating,
        style: h,
        className: ve("shadow-tooltip z-[100] backdrop-blur", n),
        children: e
      })]
    });
  },
  Si = _ref68 => {
    let {
      className: e,
      ...t
    } = _ref68;
    return /* @__PURE__ */L.jsx(Ei, {
      className: ce("flex px-16 py-8 bg-[#2E2E33E5] rounded-[6px] text-r13 shadow-tooltip backdrop-blur text-white", e),
      ...t
    });
  },
  Oi = "_button_xupwb_1",
  Ai = "_primary_xupwb_4",
  Ti = "_secondary_xupwb_7",
  Ri = "_disabled_xupwb_14",
  Pi = "_success_xupwb_35",
  ji = "_white_xupwb_39",
  Fi = "_inherit_xupwb_43",
  Qe = {
    button: Oi,
    primary: Ai,
    secondary: Ti,
    disabled: Ri,
    success: Pi,
    white: ji,
    inherit: Fi,
    "size-xs": "_size-xs_xupwb_47",
    "size-sm": "_size-sm_xupwb_50",
    "size-md": "_size-md_xupwb_53",
    "size-lg": "_size-lg_xupwb_56"
  },
  Di = se.memo(se.forwardRef((e, t) => {
    const {
      children: r,
      className: o,
      size: s = "lg",
      shape: i = "square",
      disabled: n = !1,
      message: c,
      leftIcon: u,
      rightIcon: a,
      fullWidth: f,
      onClick: d,
      type: p = "button",
      iconSize: h = 20,
      fontSize: m = "m14",
      fontColor: x = "inherit",
      colorType: k = "primary",
      colorIcon: P,
      ...R
    } = e;
    return /* @__PURE__ */L.jsxs("button", {
      disabled: n,
      className: ce("flex cursor-pointer items-center justify-center transition gap-4", i === "square" ? "rounded-[8px]" : "rounded-[40px]", (c || r) && s !== "sm" && s !== "xs" ? "px-24" : "px-12", Qe.button, Qe[k], Qe[`size-${s}`], {
        "w-full": f,
        [Qe.disabled]: n
      }, o),
      ref: t,
      type: p,
      onClick: d,
      ...R,
      children: [!!u && /* @__PURE__ */L.jsx("img", {
        src: u,
        width: h,
        height: h,
        className: ce(P && `bg-${P}`, n && "opacity-50"),
        alt: ""
      }), !!(r || c) && /* @__PURE__ */L.jsx("p", {
        className: ce(n && "opacity-50", m && `text-${m}`, x && `text-${x}`),
        children: r || c
      }), !!a && /* @__PURE__ */L.jsx("img", {
        src: a,
        width: h,
        height: h,
        className: ce(P && `bg-${P}`, n && "opacity-50"),
        alt: ""
      })]
    });
  }));
Di.displayName = "Button";
const zi = "_primary_1t5t3_1",
  Li = "_secondary_1t5t3_17",
  Mi = "_inherit_1t5t3_34",
  kt = {
    primary: zi,
    secondary: Li,
    inherit: Mi,
    "size-xs": "_size-xs_1t5t3_38",
    "size-sm": "_size-sm_1t5t3_41",
    "size-md": "_size-md_1t5t3_44",
    "size-lg": "_size-lg_1t5t3_47"
  },
  $i = {
    xs: "text-b12",
    sm: "text-b12",
    md: "text-b13",
    lg: "text-b13"
  },
  Ni = se.memo(se.forwardRef((e, t) => {
    const {
        disabled: r,
        children: o,
        className: s,
        size: i = "lg",
        onClick: n,
        rounded: c,
        color: u = "primary",
        prefixElement: a,
        suffixElement: f,
        message: d,
        disableHint: p,
        hintPosition: h,
        hintClassName: m,
        ...x
      } = e,
      k = u === "secondary" && r ? "opacity-30" : void 0,
      P = /* @__PURE__ */L.jsxs("button", {
        className: ve("flex cursor-pointer items-center justify-center transition gap-[10px] text-white py-[13px] px-16", c ? "rounded-[40px]" : "rounded-[6px]", kt.button, kt[u], kt[`size-${i}`], $i[i], s),
        ref: t,
        onClick: n,
        disabled: r,
        ...x,
        children: [a && /* @__PURE__ */L.jsx("div", {
          className: k,
          children: a
        }), /* @__PURE__ */L.jsx("div", {
          className: k,
          children: o || d
        }), f && /* @__PURE__ */L.jsx("div", {
          className: k,
          children: f
        })]
      });
    return r && p ? /* @__PURE__ */L.jsx(Si, {
      content: p,
      position: h,
      className: m,
      children: P
    }) : P;
  }));
Ni.displayName = "ButtonV2";
const Ui = _ref69 => {
    let {
      icon: e,
      onClick: t,
      className: r,
      size: o = 34,
      alt: s
    } = _ref69;
    return /* @__PURE__ */L.jsx("input", {
      type: "image",
      src: e,
      alt: s,
      width: o,
      height: o,
      className: ve("border border-black-4 bg-white-3 hover:bg-white-10 active:bg-white-5 rounded-[8px] p-[8px] transition-all", r),
      onClick: t
    });
  },
  Hi = _ref70 => {
    let {
      copy: e,
      size: t = 16,
      className: r
    } = _ref70;
    const {
      open: o,
      refs: s,
      id: i,
      floatingStyles: n,
      refElementProps: c
    } = cn({
      autoClose: !0,
      mode: "click"
    });
    if (!e) return null;
    const u = a => {
      a.stopPropagation(), c.onClick && c.onClick(a), navigator.clipboard.writeText(e);
    };
    return /* @__PURE__ */L.jsxs(L.Fragment, {
      children: [/* @__PURE__ */L.jsx("button", {
        ref: s.setReference,
        "aria-describedby": o ? i : void 0,
        onClick: u,
        className: ve("w-auto text-regular hover:text-regular-fa active:text-regular", r),
        children: /* @__PURE__ */L.jsx("svg", {
          width: t,
          height: t,
          viewBox: `0 0 ${t} ${t}`,
          fill: "currentcolor",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */L.jsx("path", {
            d: "M10.6667 13.3333H5.33333C4.8029 13.3333 4.29419 13.1225 3.91912 12.7475C3.54405 12.3724 3.33333 11.8637 3.33333 11.3333V4.66658C3.33333 4.48977 3.2631 4.3202 3.13807 4.19518C3.01305 4.07016 2.84348 3.99992 2.66667 3.99992C2.48986 3.99992 2.32029 4.07016 2.19526 4.19518C2.07024 4.3202 2 4.48977 2 4.66658V11.3333C2 12.2173 2.35119 13.0652 2.97631 13.6903C3.60143 14.3154 4.44928 14.6666 5.33333 14.6666H10.6667C10.8435 14.6666 11.013 14.5963 11.1381 14.4713C11.2631 14.3463 11.3333 14.1767 11.3333 13.9999C11.3333 13.8231 11.2631 13.6535 11.1381 13.5285C11.013 13.4035 10.8435 13.3333 10.6667 13.3333ZM14 5.95992C13.9931 5.89867 13.9796 5.83834 13.96 5.77992V5.71992C13.9279 5.65137 13.8852 5.58836 13.8333 5.53325L9.83333 1.53325C9.77822 1.4814 9.71521 1.43864 9.64667 1.40659H9.58667L9.37333 1.33325H6.66667C6.13623 1.33325 5.62753 1.54397 5.25245 1.91904C4.87738 2.29411 4.66667 2.80282 4.66667 3.33325V9.99992C4.66667 10.5304 4.87738 11.0391 5.25245 11.4141C5.62753 11.7892 6.13623 11.9999 6.66667 11.9999H12C12.5304 11.9999 13.0391 11.7892 13.4142 11.4141C13.7893 11.0391 14 10.5304 14 9.99992V5.99992C14 5.99992 14 5.99992 14 5.95992ZM10 3.60659L11.7267 5.33325H10.6667C10.4899 5.33325 10.3203 5.26301 10.1953 5.13799C10.0702 5.01297 10 4.8434 10 4.66658V3.60659ZM12.6667 9.99992C12.6667 10.1767 12.5964 10.3463 12.4714 10.4713C12.3464 10.5963 12.1768 10.6666 12 10.6666H6.66667C6.48986 10.6666 6.32029 10.5963 6.19526 10.4713C6.07024 10.3463 6 10.1767 6 9.99992V3.33325C6 3.15644 6.07024 2.98687 6.19526 2.86185C6.32029 2.73682 6.48986 2.66659 6.66667 2.66659H8.66667V4.66658C8.66667 5.19702 8.87738 5.70573 9.25245 6.0808C9.62753 6.45587 10.1362 6.66658 10.6667 6.66658H12.6667V9.99992Z"
          })
        })
      }), o && /* @__PURE__ */L.jsxs("div", {
        id: i,
        ref: s.setFloating,
        style: n,
        className: "z-[100] flex px-16 py-8 bg-[#2E2E33E5] rounded-[6px] text-r13 shadow-tooltip backdrop-blur text-white items-center gap-4",
        children: [Wi, " Copied"]
      })]
    });
  },
  Wi = /* @__PURE__ */L.jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */L.jsx("g", {
      clipPath: "url(#clip0_669_19053)",
      children: /* @__PURE__ */L.jsx("path", {
        d: "M14 4.34328L5.81176 13L2 8.8209L3.41176 7.47761L5.81176 10.1642L12.5882 3L14 4.34328Z",
        fill: "white"
      })
    }), /* @__PURE__ */L.jsx("defs", {
      children: /* @__PURE__ */L.jsx("clipPath", {
        id: "clip0_669_19053",
        children: /* @__PURE__ */L.jsx("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })
    })]
  }),
  Gi = _ref71 => {
    let {
      href: e,
      size: t = 16,
      className: r,
      target: o = "_blank",
      rel: s = "noopener noreferrer"
    } = _ref71;
    return /* @__PURE__ */L.jsx("a", {
      href: e,
      target: o,
      rel: s,
      onClick: i => i.stopPropagation(),
      className: ve("w-auto text-regular hover:text-regular-fa active:text-regular", r),
      children: /* @__PURE__ */L.jsxs("svg", {
        width: t,
        height: t,
        viewBox: `0 0 ${t} ${t}`,
        fill: "currentcolor",
        children: [/* @__PURE__ */L.jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6667 12V8C12.6667 7.632 12.9647 7.33333 13.3333 7.33333C13.702 7.33333 14 7.632 14 8V12C14 13.1027 13.1027 14 12 14H4C2.89733 14 2 13.1027 2 12V4C2 2.89733 2.89733 2 4 2H8C8.36867 2 8.66667 2.29867 8.66667 2.66667C8.66667 3.03467 8.36867 3.33333 8 3.33333H4C3.632 3.33333 3.33333 3.63267 3.33333 4V12C3.33333 12.3673 3.632 12.6667 4 12.6667H12C12.368 12.6667 12.6667 12.3673 12.6667 12ZM11.7187 3.33867L10.6634 3.33333C10.2947 3.33133 9.99807 3.03133 10.0001 2.66333C10.0021 2.296 10.3001 2 10.6667 2H10.6701L13.3347 2.01333C13.7014 2.01533 13.9981 2.31267 13.9981 2.67933L14.0001 5.33267C14.0001 5.70133 13.7021 6 13.3341 6H13.3334C12.9654 6 12.6667 5.702 12.6667 5.334L12.6661 4.27667L8.4714 8.47133C8.3414 8.60133 8.17073 8.66667 8.00007 8.66667C7.8294 8.66667 7.65873 8.60133 7.52873 8.47133C7.26807 8.21067 7.26807 7.78933 7.52873 7.52867L11.7187 3.33867Z"
        }), /* @__PURE__ */L.jsx("mask", {
          id: "mask0_14114_47736",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "2",
          y: "2",
          width: "12",
          height: "12",
          children: /* @__PURE__ */L.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.6667 12V8C12.6667 7.632 12.9647 7.33333 13.3333 7.33333C13.702 7.33333 14 7.632 14 8V12C14 13.1027 13.1027 14 12 14H4C2.89733 14 2 13.1027 2 12V4C2 2.89733 2.89733 2 4 2H8C8.36867 2 8.66667 2.29867 8.66667 2.66667C8.66667 3.03467 8.36867 3.33333 8 3.33333H4C3.632 3.33333 3.33333 3.63267 3.33333 4V12C3.33333 12.3673 3.632 12.6667 4 12.6667H12C12.368 12.6667 12.6667 12.3673 12.6667 12ZM11.7187 3.33867L10.6634 3.33333C10.2947 3.33133 9.99807 3.03133 10.0001 2.66333C10.0021 2.296 10.3001 2 10.6667 2H10.6701L13.3347 2.01333C13.7014 2.01533 13.9981 2.31267 13.9981 2.67933L14.0001 5.33267C14.0001 5.70133 13.7021 6 13.3341 6H13.3334C12.9654 6 12.6667 5.702 12.6667 5.334L12.6661 4.27667L8.4714 8.47133C8.3414 8.60133 8.17073 8.66667 8.00007 8.66667C7.8294 8.66667 7.65873 8.60133 7.52873 8.47133C7.26807 8.21067 7.26807 7.78933 7.52873 7.52867L11.7187 3.33867Z"
          })
        }), /* @__PURE__ */L.jsx("g", {
          mask: "url(#mask0_14114_47736)",
          children: /* @__PURE__ */L.jsx("rect", {
            width: t,
            height: t
          })
        })]
      })
    });
  };
export { Di as Button, Ni as ButtonV2, Hi as CopyButton, Ei as FloatingPanel, Ui as IconButton, $o as Image, Vi as Input, Gi as LinkIcon, Ii as Modal, No as Text, Si as Tooltip, ve as cxTw, Un as useDebounce, Jn as useScreenSize, cn as useTooltip };